import React, { useState, useRef, Component } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon, AlertTriangle, Eye, Search, Heart, MessageCircle, UserPlus, ThumbsDown, Target, Camera, Zap, TrendingUp, AlarmClockOff, RefreshCw, XCircle, Sparkles, Clock, MessageSquare, Repeat, BookOpen, ChevronRight, Wand2, Smartphone, Share2, Flame, Lightbulb, Tags, Monitor, Plus, Equal, Anchor, HeartHandshake, AlertCircle, HelpCircle, Gamepad2, Fingerprint, Quote, ArrowRight, PawPrint, Bird, Copy, FileText, Megaphone, Film, Smile, Link2, Ban, CheckCircle2, Rocket, Download, Apple, PlayCircle, Compass, Crown, UserCircle2, Bot, CalendarDays, Sunrise, Sun, Moon } from 'lucide-react';
import { motion } from 'framer-motion';
const topics = [{
  id: 'getting-started',
  name: 'Getting Started',
  description: 'Set up Pawchi and your Pawchi Plus access'
}, {
  id: 'account-warmup',
  name: 'Account Warmup',
  description: 'How to set up your TikTok account for success'
}, {
  id: 'posting-guidelines',
  name: 'Posting Guidelines',
  description: 'What to post, how often, and the rules you must follow'
}, {
  id: 'viral-formula',
  name: 'The Viral Formula',
  description: 'The 4 organic formats that drive Pawchi growth'
}, {
  id: 'hooks',
  name: 'Hooks & Viral Angles',
  description: 'High-leverage hook patterns + comment bait'
}, {
  id: 'finch-pawchi',
  name: 'Finch → Pawchi Examples',
  description: 'Proven Finch UGC captions, remixed for Pawchi'
}, {
  id: 'ugc-brief',
  name: 'UGC Brief',
  description: 'The complete creative brief template for Pawchi videos'
}];
export function CreatorHelpCenter() {
  const [activeTopic, setActiveTopic] = useState('getting-started');
  const mainRef = useRef<HTMLElement>(null);
  function handleTopicSelect(topicId: string) {
    setActiveTopic(topicId);
    requestAnimationFrame(() => {
      mainRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    });
  }
  return <div className="min-h-screen bg-cream" data-id="element-189" data-mp="izb17uxi0z5s">
      <div className="max-w-7xl mx-auto px-6 pt-32 pb-20" data-id="element-190" data-mp="e1jdld3vzz7e">
        <Link to="/creator" className="inline-flex items-center gap-2 text-warmBrown/60 hover:text-peach transition-colors mb-8 font-medium" data-id="element-191" data-mp="e45j7777w4mz">
          <ArrowLeftIcon size={18} data-id="element-192" data-mp="45pqizsjknbd" />
          Back to Creator Program
        </Link>

        <div className="mb-12 max-w-2xl" data-id="element-193" data-mp="3vi0wfpe91mli">
          <div className="inline-flex items-center gap-2 bg-peach/10 text-peach px-3 py-1 rounded-full text-sm font-bold mb-4" data-id="element-194" data-mp="3vgzj1e9rgo0m">
            <BookOpen size={14} data-id="element-195" data-mp="3minv5k0a44bv" />
            Creator Help Center
          </div>
          <h1 className="text-4xl md:text-5xl font-black text-warmBrown mb-4 leading-tight" data-id="element-196" data-mp="3hj1gd64syg0y">
            Everything you need to{' '}
            <span className="text-peach" data-id="element-197" data-mp="3ckzqo2cvfigi">create content that converts</span>
          </h1>
          <p className="text-warmBrown/80 text-lg leading-relaxed" data-id="element-198" data-mp="32gt00ucm44hc">
            Guides, protocols, and tips to help you grow your audience and earn
            more with Pawchi.
          </p>
        </div>

        <div className="grid md:grid-cols-[260px_1fr] gap-10" data-id="element-199" data-mp="3cf8th3z43pu0">
          {/* Sidebar */}
          <aside data-id="element-200" data-mp="3hdk3pftbk2cr">
            <div className="sticky top-32" data-id="element-201" data-mp="3hbzabtiqqpgh">
              <h4 className="text-xs font-bold uppercase tracking-wider text-warmBrown/40 mb-4" data-id="element-202" data-mp="3haxulbqs5esf">
                Topics
              </h4>
              <nav className="space-y-1" data-id="element-203" data-mp="2ontkwtgqscab">
                {topics.map(topic => <button key={topic.id} onClick={() => handleTopicSelect(topic.id)} className={`w-full text-left px-4 py-3 rounded-xl flex items-center justify-between transition-all ${activeTopic === topic.id ? 'bg-peach text-white shadow-soft' : 'text-warmBrown hover:bg-white'}`} data-id="element-204" data-mp="2tn68jgfftndy">
                    <span className="font-medium" data-id="element-205" data-mp="25vsft9ddjpsg">{topic.name}</span>
                    <ChevronRight size={16} className={activeTopic === topic.id ? 'opacity-100' : 'opacity-30'} data-id="element-206" data-mp="big8oo9cb3pr" />
                  </button>)}

                <div className="mt-6 p-4 bg-white rounded-xl border border-warmBrown/5" data-id="element-207" data-mp="ggq3uyv2e4bd">
                  <p className="text-xs text-warmBrown/60 leading-relaxed" data-id="element-208" data-mp="u7v7sd5gtiri">
                    More guides coming soon. Have a topic you want covered?{' '}
                    <Link to="/contact-us" className="text-peach font-bold hover:underline" data-id="element-209" data-mp="q8vua45o4dog">
                      Let us know
                    </Link>
                    .
                  </p>
                </div>
              </nav>
            </div>
          </aside>

          {/* Main content */}
          <main ref={mainRef} className="scroll-mt-32" data-id="element-210" data-mp="3105sj84z08lw">
            {activeTopic === 'getting-started' && <GettingStartedTopic data-id="element-211" data-mp="1ghv2cvl25iap" />}
            {activeTopic === 'account-warmup' && <AccountWarmupTopic data-id="element-212" data-mp="1lgg0mpgr1rwi" />}
            {activeTopic === 'posting-guidelines' && <PostingGuidelinesTopic data-id="element-213" data-mp="16r0btf0s3wjg" />}
            {activeTopic === 'viral-formula' && <ViralFormulaTopic data-id="element-214" data-mp="16qqmltnk5tet" />}
            {activeTopic === 'hooks' && <HooksTopic data-id="element-215" data-mp="1bpbp5zqa8p6f" />}
            {activeTopic === 'finch-pawchi' && <FinchPawchiTopic data-id="element-216" data-mp="xqbw8fvqlo4g" />}
            {activeTopic === 'ugc-brief' && <UgcBriefTopic data-id="element-217" data-mp="xor5708msnbc" />}
          </main>
        </div>
      </div>
    </div>;
}
function GettingStartedTopic() {
  const steps = [{
    number: 1,
    title: 'Download Pawchi',
    icon: <Download size={22} data-id="element-218" data-mp="ntpgg5i9pn9a" />,
    color: 'peach' as const,
    content: <>
          <p className="text-warmBrown/80 leading-relaxed mb-5" data-id="element-219" data-mp="srr7pdpuksvu">
            Pawchi is available on iOS and Android. Tap the matching badge for
            your phone to install.
          </p>
          <div className="flex flex-col sm:flex-row gap-3" data-id="element-220" data-mp="2n3yz4h2ymrmv">
            <motion.a href="https://apps.apple.com/us/app/pawchi-self-care-pet/id6764858701" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.97
        }} className="inline-block" data-id="element-221" data-mp="2lntkdhirurul">
              <img src="https://cdn.magicpatterns.com/uploads/bgW7hVXTEHmConMeGXzro4/app-store.svg" alt="Download on the App Store" className="h-[52px] w-auto" data-id="element-222" data-mp="27qogno6j652i" />
            </motion.a>
            <motion.a href="https://play.google.com/store/apps/details?id=app.pawchi.mobile" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.97
        }} className="inline-block -ml-3 sm:ml-0" data-id="element-223" data-mp="2unq0gur3iie1">
              <img src="https://cdn.magicpatterns.com/uploads/omQrJZxYBdQEgWZzBHqrye/play-store.png" alt="Get it on Google Play" className="h-[76px] w-auto -my-3" data-id="element-224" data-mp="14whlwjjlhi1j" />
            </motion.a>
          </div>
        </>
  }, {
    number: 2,
    title: 'Create your Pawchi',
    icon: <PawPrint size={22} data-id="element-225" data-mp="1ite98b0i8hdo" />,
    color: 'coral' as const,
    content: <>
          <p className="text-warmBrown/80 leading-relaxed mb-4" data-id="element-226" data-mp="1nshffys80tn8">
            Upload a photo of your pet to transform them into your digital
            Pawchi companion. Pick a clear, well-lit shot for the best
            transformation.
          </p>
          <Callout color="peach" icon={<HeartHandshake size={16} data-id="element-228" data-mp="21o2xtn3y8f6o" />} title="Don't have a pet?" data-id="element-227" data-mp="21m8fmgk2b16a">
            No problem! Use any pet photo you love, or{' '}
            <strong data-id="element-229" data-mp="2bjd08by9eokz">contact us</strong> and we'll assign one for you.
          </Callout>
          <Callout color="lavender" icon={<Sparkles size={16} data-id="element-231" data-mp="1mj3o3arjdpm3" />} title="Pro tip: make it unique" data-id="element-230" data-mp="1mghfr8wtn62t">
            Add a <strong data-id="element-232" data-mp="1hk0jtsjdrnf6">funny feature or accessory</strong> to your Pawchi —
            sunglasses, a tiny hat, a chef's apron, anything weird. A
            one-of-a-kind look is what makes viewers stop scrolling and comment.
          </Callout>
        </>
  }, {
    number: 3,
    title: 'Complete onboarding',
    icon: <CheckCircle2 size={22} data-id="element-233" data-mp="yrokleo0x299" />,
    color: 'lavender' as const,
    content: <>
          <p className="text-warmBrown/80 leading-relaxed mb-4" data-id="element-234" data-mp="1cikys0h7dgws">
            Walk through the onboarding flow inside the app. This sets up your
            habits, mood tracker, and connects everything to your new Pawchi.
          </p>
          <Callout color="coral" icon={<Film size={16} data-id="element-236" data-mp="g0wzxgyl5pfk" />} title="Hit record before you start" data-id="element-235" data-mp="k17j5vbe2ccd">
            Screen-record your onboarding so you can{' '}
            <strong data-id="element-237" data-mp="5w8ap5o6zl5b">capture the emotional transformation</strong> from your real
            pet to the digitized Pawchi. That reveal moment is your most viral
            asset — you only get one first reaction, so don't miss it.
          </Callout>
        </>
  }, {
    number: 4,
    title: 'Explore the app',
    icon: <Compass size={22} data-id="element-238" data-mp="vsu858m5xj4" />,
    color: 'sage' as const,
    content: <p className="text-warmBrown/80 leading-relaxed" data-id="element-239" data-mp="oo124vnm4yax">
          Tap around. Get comfortable with how habits, the mood log, breathing
          exercises, and your Pawchi's reactions all fit together. The more
          familiar you are, the more genuine your videos will feel.
        </p>
  }, {
    number: 5,
    title: 'Unlock Pawchi Plus',
    icon: <Crown size={22} data-id="element-240" data-mp="2zf9izrqyn582" />,
    color: 'peach' as const,
    content: <>
          <p className="text-warmBrown/80 leading-relaxed mb-4" data-id="element-241" data-mp="34f5hjbgw24g8">
            Once you've explored the app,{' '}
            <strong className="text-warmBrown" data-id="element-242" data-mp="1ijc8ck2xpi77">let us know</strong> — we'll
            grant you Pawchi Plus, which unlocks all animations and premium
            features so your content can showcase the full experience.
          </p>
          <Callout color="lavender" icon={<Sparkles size={16} data-id="element-244" data-mp="1dqsudm0c4l1v" />} title="Need more Pawchis?" data-id="element-243" data-mp="18s7wvucgwfh4">
            If you want to feature additional pets in your content, contact us
            for <strong data-id="element-245" data-mp="14qweo9vxawiy">extra credits</strong>.
          </Callout>
        </>
  }];
  const colorMap = {
    peach: {
      bg: 'bg-peach/10',
      text: 'text-peach',
      solid: 'bg-peach'
    },
    coral: {
      bg: 'bg-coral/10',
      text: 'text-coral',
      solid: 'bg-coral'
    },
    lavender: {
      bg: 'bg-lavender/10',
      text: 'text-lavender',
      solid: 'bg-lavender'
    },
    sage: {
      bg: 'bg-sage/10',
      text: 'text-sage',
      solid: 'bg-sage'
    }
  };
  return <motion.article initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.4
  }} className="space-y-10" data-id="element-246" data-mp="diusuj8r3rd7">
      {/* Intro */}
      <header data-id="element-247" data-mp="naie22epsc68">
        <div className="inline-flex items-center gap-2 bg-sage/10 text-sage px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider mb-4" data-id="element-248" data-mp="nba838sny1ue">
          <Rocket size={14} data-id="element-249" data-mp="w8uf6yd7iscx" />
          Start Here
        </div>
        <h2 className="text-3xl md:text-4xl font-black text-warmBrown mb-4" data-id="element-250" data-mp="s8ahntoq1mq9">
          Getting Started with Pawchi
        </h2>
        <p className="text-warmBrown/80 text-lg leading-relaxed" data-id="element-251" data-mp="168bjbbct8y6s">
          Welcome to the Pawchi Creator Program! Follow these{' '}
          <strong className="text-warmBrown" data-id="element-252" data-mp="119run36u18aq">5 quick steps</strong> to get set
          up with the app, unlock Pawchi Plus, and start creating content.
        </p>
      </header>

      {/* What is Pawchi */}
      <section className="bg-gradient-to-br from-peach to-coral rounded-3xl p-8 md:p-10 text-white" data-id="element-253" data-mp="332g1rnmlkfvs">
        <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider mb-4" data-id="element-254" data-mp="16z9ysgq7r5td">
          <PawPrint size={14} data-id="element-255" data-mp="1fwtyvmccaw2e" />
          What is Pawchi?
        </div>
        <p className="text-xl md:text-2xl font-bold leading-snug mb-3" data-id="element-256" data-mp="1kwq7jyvzfboa">
          Pawchi turns your real pet into a cute digital companion.
        </p>
        <p className="text-white/90 leading-relaxed" data-id="element-257" data-mp="1pvjhjhc28kjp">
          Keep them happy by completing daily habits, tracking your mood, and
          taking moments to breathe. Self-care, gamified — and powered by the
          pet you actually love.
        </p>
      </section>

      {/* Steps */}
      <section className="space-y-5" data-id="element-258" data-mp="23my39vxcqzug">
        {steps.map(step => {
        const c = colorMap[step.color];
        return <article key={step.number} className="bg-white rounded-3xl p-8 shadow-soft border border-warmBrown/5" data-id="element-259" data-mp="28kpv6pxzylyn">
              <div className="flex items-start gap-4 mb-5" data-id="element-260" data-mp="2nqdfp9ibom4w">
                <div className={`w-14 h-14 rounded-2xl ${c.solid} text-white flex items-center justify-center flex-shrink-0 font-black text-xl`} data-id="element-261" data-mp="2iqr392abj9x5">
                  {step.number}
                </div>
                <div className="flex-1 min-w-0" data-id="element-262" data-mp="29r4crbj4noiv">
                  <div className="flex items-center gap-2 mb-1" data-id="element-263" data-mp="36g27wuushogk">
                    <span className={c.text} data-id="element-264" data-mp="36facbk16zqqa">{step.icon}</span>
                    <p className={`text-xs font-bold uppercase tracking-wider ${c.text}`} data-id="element-265" data-mp="31gpchlpur92d">
                      Step {step.number}
                    </p>
                  </div>
                  <h3 className="text-2xl font-black text-warmBrown" data-id="element-266" data-mp="2snvtbd7abpj8">
                    {step.title}
                  </h3>
                </div>
              </div>
              <div data-id="element-267" data-mp="3kfbb8txwco34">{step.content}</div>
            </article>;
      })}
      </section>

      {/* Contact us */}
      <section className="bg-warmBrown rounded-3xl p-8 md:p-10 text-cream" data-id="element-268" data-mp="34ws5k6ktik0w">
        <div className="flex items-start gap-4 mb-4" data-id="element-269" data-mp="39xfyixslxaxr">
          <div className="w-12 h-12 rounded-full bg-peach/20 text-peach flex items-center justify-center flex-shrink-0" data-id="element-270" data-mp="39utq6vxw6reh">
            <UserCircle2 size={22} data-id="element-271" data-mp="2zyqpzvmlp2u6" />
          </div>
          <div data-id="element-272" data-mp="2zziaobentg5o">
            <h3 className="text-2xl font-black mb-1" data-id="element-273" data-mp="2zz0fli3qh7zc">Need help? Contact us</h3>
            <p className="text-cream/60 text-sm" data-id="element-274" data-mp="3npmbkb0gr1sz">
              For Pawchi Plus access, extra credits, or anything you get stuck
              on.
            </p>
          </div>
        </div>
        <Link to="/contact-us" className="inline-flex items-center gap-2 px-6 py-3 bg-peach hover:bg-peach/90 text-white rounded-full font-bold transition-colors mt-4" data-id="element-275" data-mp="3euyayy5u28ai">
          Get in touch
          <ArrowRight size={16} data-id="element-276" data-mp="ag84gp6vbymr" />
        </Link>
      </section>

      {/* Copyright rules */}
      <section className="bg-white rounded-3xl p-8 md:p-10 shadow-soft border border-coral/20" data-id="element-277" data-mp="fa2m7n2wy3j7">
        <div className="flex items-start gap-4 mb-5" data-id="element-278" data-mp="1zxc3uhz1btsb">
          <div className="w-12 h-12 rounded-full bg-coral/10 text-coral flex items-center justify-center flex-shrink-0" data-id="element-279" data-mp="1v03nmmxg5ztp">
            <Ban size={22} data-id="element-280" data-mp="29nom23jdnava" />
          </div>
          <div data-id="element-281" data-mp="29qsw3hjix0tv">
            <p className="text-xs font-bold uppercase tracking-wider text-coral mb-1" data-id="element-282" data-mp="24pn2lhi1h9ja">
              Non-Negotiable
            </p>
            <h3 className="text-2xl font-black text-warmBrown" data-id="element-283" data-mp="1gz9c3vf3riqt">
              No Copyrighted or Trademarked Plushies
            </h3>
            <p className="text-warmBrown/60 text-sm mt-1" data-id="element-284" data-mp="1c2smsxw62yc5">
              Applies to your Pawchi and to anything visible on camera.
            </p>
          </div>
        </div>

        <p className="text-warmBrown/80 leading-relaxed mb-5" data-id="element-285" data-mp="1ly45tselyrpp">
          Licensed characters and branded plushies are protected trademarks. Do
          not turn them into a Pawchi, and do not feature them in your content —
          it exposes both you and Pawchi to takedowns and legal risk.
        </p>

        <p className="text-xs font-bold uppercase tracking-wider text-warmBrown/40 mb-2" data-id="element-286" data-mp="34gphb9uuvfnw">
          Do not use
        </p>
        <div className="flex flex-wrap gap-2 mb-5" data-id="element-287" data-mp="39iolglyf6glw">
          {['Disney characters', 'Jellycat', 'Squishmallows', 'Sanrio / Hello Kitty', 'Pokémon', 'Build-A-Bear licensed lines', 'Any branded or licensed character plush'].map(brand => <span key={brand} className="px-3 py-1.5 bg-coral/10 text-coral rounded-lg font-bold text-sm border border-coral/20" data-id="element-288" data-mp="2qpkoaqlztlmj">
              {brand}
            </span>)}
        </div>

        <Callout color="sage" icon={<CheckCircle2 size={16} data-id="element-290" data-mp="230jf315c66g7" />} title="Use this instead" data-id="element-289" data-mp="30hgnk4ztfhsc">
          Your <strong data-id="element-291" data-mp="22yoyu050f2ig">real pet</strong>, a{' '}
          <strong data-id="element-292" data-mp="27ykth8rthhlc">generic, unbranded plushie or stuffed animal</strong>, or a
          non-licensed figure. Unbranded companions work better anyway — the
          story is your bond with them, not the brand on the tag.
        </Callout>
      </section>

      {/* Next steps */}
      <Callout color="sage" icon={<Lightbulb size={18} data-id="element-294" data-mp="g28ri0rdkjid" />} title="Once you're set up" data-id="element-293" data-mp="g3ae92hr6ufx">
        Jump to <strong data-id="element-295" data-mp="b3nro2g1c1ug">Account Warmup</strong> next to prep your TikTok or
        Instagram account before posting your first Pawchi video. The warmup is
        the #1 reason new creators see early traction.
      </Callout>
    </motion.article>;
}
function AccountWarmupTopic() {
  return <motion.article initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.4
  }} className="space-y-10" data-id="element-296" data-mp="3thwzoldb2olj">
      {/* Intro */}
      <header data-id="element-297" data-mp="3jmmtdlfvjv1y">
        <div className="inline-flex items-center gap-2 bg-coral/10 text-coral px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider mb-4" data-id="element-298" data-mp="3elfmdolk2zwc">
          <AlertTriangle size={14} data-id="element-299" data-mp="17bk0yer27ya6" />
          Non-Negotiable
        </div>
        <h2 className="text-3xl md:text-4xl font-black text-warmBrown mb-4" data-id="element-300" data-mp="1bc3y3ibmv1wb">
          Account Warmup Protocol
        </h2>
        <p className="text-warmBrown/80 text-lg leading-relaxed" data-id="element-301" data-mp="xb9qh1wet4yp">
          Starting a new account without warmup is the{' '}
          <strong className="text-warmBrown" data-id="element-302" data-mp="12d8ri54ofpsh">
            #1 reason first videos flop
          </strong>
          . TikTok needs behavioral signal before it knows who to show your
          content to.
        </p>
      </header>

      {/* Step 0: Handle Setup */}
      <section className="bg-white rounded-3xl p-8 md:p-10 shadow-soft border border-warmBrown/5" data-id="element-303" data-mp="emux47ymdeuq">
        <div className="flex items-start gap-4 mb-5" data-id="element-304" data-mp="jlfy49lp42k8">
          <div className="w-14 h-14 rounded-2xl bg-warmBrown text-cream flex items-center justify-center flex-shrink-0 font-black text-xl" data-id="element-305" data-mp="4ndwi4y85r5m">
            0
          </div>
          <div className="flex-1 min-w-0" data-id="element-306" data-mp="9lp6qgsfm3od">
            <p className="text-xs font-bold uppercase tracking-wider text-warmBrown/40 mb-1" data-id="element-307" data-mp="3m5jfbmcmt2cl">
              Before You Begin
            </p>
            <h3 className="text-2xl font-black text-warmBrown" data-id="element-308" data-mp="3i627wndn9v4s">
              Set Up Your Accounts
            </h3>
            <p className="text-warmBrown/60 text-sm mt-1" data-id="element-309" data-mp="3w25wa01u799c">
              Follow these five steps in order — you'll need your Pawchi Media
              email before you can create your accounts.
            </p>
          </div>
        </div>

        <div className="space-y-5" data-id="element-310" data-mp="4yhbcrxs9wbu">
          <div data-id="element-311" data-mp="4xfx6elh0tpw">
            <p className="text-xs font-bold uppercase tracking-wider text-peach mb-2" data-id="element-312" data-mp="4vv30q32jcsk">
              Step 1 · Send us your personal email address
            </p>
            <p className="text-warmBrown/80 leading-relaxed" data-id="element-313" data-mp="drarerl20zqr">
              Start here. Send us your{' '}
              <strong className="text-warmBrown" data-id="element-314" data-mp="soblv2umr8sx">
                personal email address
              </strong>{' '}
              so we can set you up. Don't create any accounts yet.
            </p>
          </div>

          <div data-id="element-315" data-mp="105m1ri11ccto">
            <p className="text-xs font-bold uppercase tracking-wider text-peach mb-2" data-id="element-316" data-mp="1099uieynov7c">
              Step 2 · Get your Pawchi Media email
            </p>
            <p className="text-warmBrown/80 leading-relaxed" data-id="element-317" data-mp="196tz9xvq99mp">
              We'll reply with a{' '}
              <strong className="text-warmBrown" data-id="element-318" data-mp="157bdz0zzuwjc">
                dedicated @pawchimedia email address
              </strong>
              . This is the email you'll use to sign up on TikTok and Instagram
              — it keeps your creator accounts clean and separate from your
              personal inbox.
            </p>
          </div>

          <div data-id="element-319" data-mp="qb3wi8fz097r">
            <p className="text-xs font-bold uppercase tracking-wider text-peach mb-2" data-id="element-320" data-mp="liasjmsbt4wq">
              Step 3 · Pick your handle
            </p>
            <p className="text-warmBrown/80 leading-relaxed mb-3" data-id="element-321" data-mp="3tx18t33g31l7">
              Choose the same handle for TikTok and Instagram. We recommend{' '}
              <strong className="text-warmBrown" data-id="element-322" data-mp="3puoa2yn483xx">your name + pet name</strong>{' '}
              or something{' '}
              <strong className="text-warmBrown" data-id="element-323" data-mp="3kj0scaalmwx8">
                wellness / self-care related
              </strong>
              .
            </p>

            <p className="text-xs font-bold uppercase tracking-wider text-warmBrown/40 mb-2" data-id="element-324" data-mp="35vxw06y0iubh">
              Examples
            </p>
            <div className="flex flex-wrap gap-2" data-id="element-325" data-mp="3ar4vf2k91cul">
              {['@miguelandpolo', '@dailypolo', '@dailylifeofatlas', '@atlasselfcare'].map(handle => <span key={handle} className="px-3 py-1.5 bg-peach/10 text-peach rounded-lg font-bold text-sm border border-peach/20" data-id="element-326" data-mp="3ojueoz8e83o0">
                  {handle}
                </span>)}
            </div>
          </div>

          <div data-id="element-327" data-mp="2i5boqhvu1e2j">
            <p className="text-xs font-bold uppercase tracking-wider text-peach mb-2" data-id="element-328" data-mp="2i5v2dmeg9gar">
              Step 4 · Create your accounts
            </p>
            <p className="text-warmBrown/80 leading-relaxed mb-3" data-id="element-329" data-mp="onw3xa3hbekg">
              Use your{' '}
              <strong className="text-warmBrown" data-id="element-330" data-mp="jpchl8kz40rk">@pawchimedia email</strong> to
              create your TikTok and Instagram accounts under your chosen
              handle. Then fill out the profile:
            </p>
            <ul className="space-y-2 mb-4" data-id="element-331" data-mp="4y3tx50msph2">
              <li className="flex items-start gap-3 text-warmBrown/80" data-id="element-332" data-mp="4yvgjqc93cv7">
                <CheckCircle2 size={18} className="text-peach mt-0.5 flex-shrink-0" data-id="element-333" data-mp="vz3ef5hc8yn" />
                Use a{' '}
                <strong className="text-warmBrown" data-id="element-334" data-mp="3s4mr31r7089d">
                  genuine, authentic photo of you and your pet
                </strong>{' '}
                as your profile picture
              </li>
              <li className="flex items-start gap-3 text-warmBrown/80" data-id="element-335" data-mp="1q92kgojxm3xr">
                <CheckCircle2 size={18} className="text-peach mt-0.5 flex-shrink-0" data-id="element-336" data-mp="1ld55alken3mk" />
                Write a short, friendly bio that hints at the self-care + pet
                vibe
              </li>
              <li className="flex items-start gap-3 text-warmBrown/80" data-id="element-337" data-mp="22l4sqp186gqz">
                <CheckCircle2 size={18} className="text-peach mt-0.5 flex-shrink-0" data-id="element-338" data-mp="27krdrknap1ac" />
                Keep the same handle, photo, and bio consistent across TikTok
                and Instagram
              </li>
            </ul>
            <Callout color="sage" icon={<Heart size={16} data-id="element-340" data-mp="1ju56hvl47l1e" />} title="Why authentic matters" data-id="element-339" data-mp="1ey6dfuoudeun">
              Real-you-with-real-pet photos build trust instantly. Stock images,
              AI portraits, or pet-only photos look like a brand account — which
              kills the personal-discovery feel that drives conversions.
            </Callout>
          </div>

          <div data-id="element-341" data-mp="2xuruyb054ibo">
            <p className="text-xs font-bold uppercase tracking-wider text-peach mb-2" data-id="element-342" data-mp="2xu89ikba7bsw">
              Step 5 · Submit your handles
            </p>
            <p className="text-warmBrown/80 leading-relaxed" data-id="element-343" data-mp="2tuzhpkzsxnzz">
              Once both accounts exist, send us your{' '}
              <strong className="text-warmBrown" data-id="element-344" data-mp="37ql3ljaqnro6">
                final TikTok and Instagram handles
              </strong>{' '}
              so we can track your content and payouts. Then start your warmup
              below.
            </p>
          </div>

          <Link to="/contact-us" className="inline-flex items-center gap-2 px-6 py-3 bg-peach hover:bg-peach/90 text-white rounded-full font-bold transition-colors" data-id="element-345" data-mp="3cr936td19gu0">
            Contact us
            <ArrowRight size={16} data-id="element-346" data-mp="3ll475y2f5182" />
          </Link>
        </div>
      </section>

      {/* Days 1-2 */}
      <PhaseCard phase="Days 1–2" title="Pure Observer Mode" color="lavender" icon={<Eye size={24} data-id="element-348" data-mp="3vgp7lrru9tfp" />} data-id="element-347" data-mp="4a4lmmgn5bpj">
        <div className="space-y-4" data-id="element-349" data-mp="iye9txaj0dlv">
          <Rule icon={<XCircle size={18} data-id="element-351" data-mp="izpiobitwbju" />} negative data-id="element-350" data-mp="izfo0amu9g7t">
            Do <strong data-id="element-352" data-mp="n117wfxsiuri">NOT</strong> post anything
          </Rule>
          <Rule icon={<Clock size={18} data-id="element-354" data-mp="90qhtf4b1k7e" />} data-id="element-353" data-mp="my6omrqijfzo">
            Open app <strong data-id="element-355" data-mp="8zouoca0l79b">2× per day</strong>, 10 minutes each session
          </Rule>
          <Rule icon={<Search size={18} data-id="element-357" data-mp="dz1nrerhbakc" />} data-id="element-356" data-mp="dzbg38zzxtt7">
            Search your exact niche:{' '}
            <em className="text-warmBrown/70" data-id="element-358" data-mp="3vgkwh1ninp08">
              "pet care routine," "self-care habits," "tamagotchi," "virtual
              pet," "cat routine," "dog self care"
            </em>
          </Rule>
          <Rule icon={<Eye size={18} data-id="element-360" data-mp="3mgfsl1hj78qt" />} data-id="element-359" data-mp="3mg69lxuwm1um">
            Watch every video <strong data-id="element-361" data-mp="3mdju9c1rui1u">TO THE END</strong> — partial watches are
            negative signals
          </Rule>
          <Rule icon={<Heart size={18} data-id="element-363" data-mp="3chgq60nd09c9" />} data-id="element-362" data-mp="3rcd6l15bo30f">
            Like <strong data-id="element-364" data-mp="3cii4qf3l3dyq">20–30 niche videos</strong> per day
          </Rule>
          <Rule icon={<MessageCircle size={18} data-id="element-366" data-mp="3hh37oma80bqv" />} data-id="element-365" data-mp="3hga5lym7iaf2">
            Leave <strong data-id="element-367" data-mp="3hfryu81x4dsw">5 genuine comments</strong> (full sentences, not
            emojis or one-word replies)
          </Rule>
          <Rule icon={<UserPlus size={18} data-id="element-369" data-mp="2tlhyf8jyuyl6" />} data-id="element-368" data-mp="2tl86vgj9wjdd">
            Follow <strong data-id="element-370" data-mp="2tkgbo6tl8nnm">3–5 relevant accounts</strong>
          </Rule>
          <Rule icon={<ThumbsDown size={18} data-id="element-372" data-mp="2olc41kmbaxze" />} data-id="element-371" data-mp="2ollutaf6l965">
            Aggressively tap <strong data-id="element-373" data-mp="2ojsjvixjc2sc">"Not Interested"</strong> on anything
            off-niche
          </Rule>
        </div>

        <Callout color="sage" icon={<Target size={18} data-id="element-375" data-mp="3hb2i5tny1zvi" />} title="Goal by Day 2" data-id="element-374" data-mp="3hasptzfffgmn">
          Your For You Page shows pet content, self-care content, habit apps,
          and cute animal transformations. If it doesn't,{' '}
          <strong data-id="element-376" data-mp="37c3gww5id6ij">you moved too fast</strong>.
        </Callout>
      </PhaseCard>

      {/* Engagement Mix */}
      <section className="bg-white rounded-3xl p-8 md:p-10 shadow-soft border border-warmBrown/5" data-id="element-377" data-mp="32ebev9b5g40m">
        <div className="flex items-start gap-4 mb-6" data-id="element-378" data-mp="1vxpw6061x76q">
          <div className="w-12 h-12 rounded-full bg-peach/10 text-peach flex items-center justify-center flex-shrink-0" data-id="element-379" data-mp="1vv3hlgkqtrf0">
            <Target size={22} data-id="element-380" data-mp="6gm28mwnm48k" />
          </div>
          <div data-id="element-381" data-mp="6hx76q1u5i19">
            <h3 className="text-2xl font-black text-warmBrown mb-1" data-id="element-382" data-mp="6e9bbk8x4jjd">
              Your Engagement Mix
            </h3>
            <p className="text-warmBrown/60 text-sm" data-id="element-383" data-mp="geiclchrov5m">
              The exact ratio of content to watch, like, and comment on during
              warmup.
            </p>
          </div>
        </div>

        <div className="space-y-4" data-id="element-384" data-mp="q4bl24mm4u5n">
          <EngagementBucket percent={30} label="Pets" color="peach" items={['Funny dog videos', 'Pet POV content', 'Pet-owner relatable content', 'Cute animal clips', 'Pet transformations']} goal="Tell TikTok you're interested in pet owners." data-id="element-385" data-mp="q39z35426n95" />
          <EngagementBucket percent={30} label="Plushies & Stuffed Animals" color="coral" items={['Plushie collecting', 'Stuffed animal care', 'Plushie adventures', 'Comfort items', 'Cozy and nostalgic toy content']} goal="Reach people drawn to the comfort, care, security, and nostalgia of a beloved companion." data-id="element-386" data-mp="30xeenrr2vmvs" />
          <EngagementBucket percent={20} label="Self-Care" color="lavender" items={['Water intake', 'Morning routines', 'Habit tracking', 'Self-improvement', 'Wellness content']} goal="Tell TikTok you're interested in people actively trying to improve themselves." data-id="element-387" data-mp="1geltsn05iqes" />
          <EngagementBucket percent={20} label="Productivity / Mental Health" color="sage" items={['Atomic Habits', 'Motivation', 'Journaling', 'ADHD productivity', '"Get your life together" content']} goal="Reach the audience that actually installs apps." data-id="element-388" data-mp="xnksvtfh0ksl" />
        </div>
      </section>

      {/* Day 3 */}
      <PhaseCard phase="Day 3" title="Diagnostic Posting" color="peach" icon={<Camera size={24} data-id="element-390" data-mp="2bnfov6w740gt" />} data-id="element-389" data-mp="27lu2muxru9ty">
        <p className="text-warmBrown/80 leading-relaxed mb-4" data-id="element-391" data-mp="2bogwt2hx06ub">
          Before posting real content, post <strong data-id="element-392" data-mp="2ze1i3s1jjg6r">2 slideshows</strong> (low
          production effort). These are diagnostic tools.
        </p>

        <div className="bg-cream/60 rounded-2xl p-6 mb-4" data-id="element-393" data-mp="34as0im0tinvc">
          <p className="font-bold text-warmBrown mb-3" data-id="element-394" data-mp="2qkybo3pbc3lm">
            A slideshow "passed" if within 5 hours it gets:
          </p>
          <ul className="space-y-2" data-id="element-395" data-mp="2ukyyocqh9n4a">
            <li className="flex items-center gap-3 text-warmBrown/80" data-id="element-396" data-mp="2uk74n6cj3xg4">
              <span className="w-2 h-2 rounded-full bg-peach" data-id="element-397" data-mp="3iab5x728vl3y"></span>
              <strong className="text-warmBrown" data-id="element-398" data-mp="3n2uhjyhdg664">500+</strong> impressions
            </li>
            <li className="flex items-center gap-3 text-warmBrown/80" data-id="element-399" data-mp="seqdw2i5usbv">
              <span className="w-2 h-2 rounded-full bg-peach" data-id="element-400" data-mp="scdwprk88lzv"></span>
              <strong className="text-warmBrown" data-id="element-401" data-mp="we8zl0ht37fr">20–30+</strong> likes
            </li>
          </ul>
        </div>

        <div className="grid sm:grid-cols-2 gap-3" data-id="element-402" data-mp="118lkzg2uesu5">
          <div className="bg-sage/10 border border-sage/20 rounded-xl p-4" data-id="element-403" data-mp="165v82p2reset">
            <p className="text-sm font-bold text-sage mb-1" data-id="element-404" data-mp="9fm60x2cv4ls">✓ If it passes</p>
            <p className="text-sm text-warmBrown/80" data-id="element-405" data-mp="9hp6kb14wg4r">
              Post up to 3 main videos that same day.
            </p>
          </div>
          <div className="bg-coral/10 border border-coral/20 rounded-xl p-4" data-id="element-406" data-mp="ifrelajac91j">
            <p className="text-sm font-bold text-coral mb-1" data-id="element-407" data-mp="neuaa4ddl2wu">✗ If it fails</p>
            <p className="text-sm text-warmBrown/80" data-id="element-408" data-mp="ncr9qqeljrdv">
              Do one more day of observer mode. Your account is still cold.
            </p>
          </div>
        </div>
      </PhaseCard>

      {/* Day 4+ */}
      <PhaseCard phase="Day 4+" title="Active Posting" color="sage" icon={<Zap size={24} data-id="element-410" data-mp="3ed8eq65kl5ix" />} data-id="element-409" data-mp="3jcbkjstdjfry">
        <div className="space-y-4" data-id="element-411" data-mp="3ee9rqg65c23a">
          <Rule icon={<Camera size={18} data-id="element-413" data-mp="3efkv4evoj7tv" />} data-id="element-412" data-mp="3ee09jercez85">
            Post <strong data-id="element-414" data-mp="39lqejkbdf8z0">1–2 videos per day</strong>
          </Rule>
          <Rule icon={<Repeat size={18} data-id="element-416" data-mp="34nf3x7d94ufq" />} data-id="element-415" data-mp="39k5l5y0slw2q">
            Continue the daily feed engagement routine (10 min, 2×/day) —{' '}
            <strong data-id="element-417" data-mp="30md34m3osabn">this is not optional</strong>
          </Rule>
          <Rule icon={<TrendingUp size={18} data-id="element-419" data-mp="30jh7x5j83zqw" />} data-id="element-418" data-mp="30jqx4qwg22vj">
            Watch performance and adjust format based on what's holding viewers
          </Rule>
        </div>
      </PhaseCard>

      {/* Fast follower growth */}
      <section className="bg-white rounded-3xl p-8 md:p-10 shadow-soft border border-warmBrown/5" data-id="element-420" data-mp="2qph1n0c7gogl">
        <div className="flex items-start gap-4 mb-6" data-id="element-421" data-mp="owasf2n3k8fp">
          <div className="w-12 h-12 rounded-full bg-peach/10 text-peach flex items-center justify-center flex-shrink-0" data-id="element-422" data-mp="ouzrdal1desa">
            <UserPlus size={22} data-id="element-423" data-mp="jxzlazo6sc16" />
          </div>
          <div data-id="element-424" data-mp="2ecwo5dq9un3b">
            <h3 className="text-2xl font-black text-warmBrown mb-1" data-id="element-425" data-mp="2ecdc2dnaysx7">
              Gaining Followers Quickly
            </h3>
            <p className="text-warmBrown/60 text-sm" data-id="element-426" data-mp="2j5fze41hl64y">
              How to get your UGC account past zero and actually start getting
              views.
            </p>
          </div>
        </div>

        <p className="text-warmBrown/80 leading-relaxed mb-6" data-id="element-427" data-mp="29el98ol4dme8">
          Want to gain followers quickly on your UGC account and start actually
          getting views? Work the follower lists of creators who already have
          your exact audience.
        </p>

        <ol className="space-y-3 mb-6" data-id="element-428" data-mp="2o26cqjlwpnmo">
          {['Search the top creators in your niche.', 'Go through their recent followers and follow them.', 'Keep going until Meta and TikTok restrict you.', 'Set a recurring timer for one hour.', 'Repeat.'].map((step, idx) => <li key={step} className="flex items-start gap-3" data-id="element-429" data-mp="1gnjrqgtyferj" data-mpi={idx}>
              <span className="mt-0.5 w-6 h-6 rounded-full bg-peach/15 text-peach flex items-center justify-center font-black text-xs flex-shrink-0" data-id="element-430" data-mp="194u0o5f0g6h1">
                {idx + 1}
              </span>
              <span className="text-warmBrown/80 leading-relaxed" data-id="element-431" data-mp="1j39p20mnl1mu">{step}</span>
            </li>)}
        </ol>

        <Callout color="peach" icon={<Target size={16} data-id="element-433" data-mp="1e3dk9z64t668" />} title="Why it works" data-id="element-432" data-mp="1e5zuk6kepzs5">
          People who recently followed a creator in your niche are already warm
          — they are actively looking for more of this content, so a meaningful
          share of them follow back.
        </Callout>
      </section>

      {/* Abandonment Rule */}
      <section className="bg-warmBrown rounded-3xl p-8 md:p-10 text-cream" data-id="element-434" data-mp="vf0a9inuxe57">
        <div className="flex items-start gap-4 mb-4" data-id="element-435" data-mp="vcvykejpvaud">
          <div className="w-12 h-12 rounded-full bg-coral/20 text-coral flex items-center justify-center flex-shrink-0" data-id="element-436" data-mp="7o4eybk700t7">
            <AlarmClockOff size={22} data-id="element-437" data-mp="2pt1lquov868" />
          </div>
          <div data-id="element-438" data-mp="324lq4tpm063s">
            <h3 className="text-2xl font-black mb-1" data-id="element-439" data-mp="3253jnikw0680">
              Account Abandonment Rule
            </h3>
            <p className="text-cream/60 text-sm" data-id="element-440" data-mp="366gu65yxcxl9">
              When to cut your losses and restart.
            </p>
          </div>
        </div>

        <div className="space-y-4 text-cream/80 leading-relaxed" data-id="element-441" data-mp="3fvgrzm1oxmxv">
          <p data-id="element-442" data-mp="3fwrw5mz1swpi">
            If <strong className="text-cream" data-id="element-443" data-mp="3fxjper56aicm">6 consecutive videos</strong> stay
            under 300 views: post 3 videos recorded natively inside TikTok (no
            external edits, no CapCut). Sometimes this resets the trust signal.
          </p>
          <p data-id="element-444" data-mp="3tuzx05z7gi5y">
            If still nothing after those 3 videos:{' '}
            <strong className="text-cream" data-id="element-445" data-mp="2oou04amx7bz">abandon the account</strong>. Restart
            costs 2 days. Staying on a dead account costs weeks.
          </p>
        </div>
      </section>

      {/* Retention Benchmark */}
      <section className="bg-gradient-to-br from-peach to-coral rounded-3xl p-8 md:p-10 text-white" data-id="element-446" data-mp="24fif173e6grd">
        <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider mb-4" data-id="element-447" data-mp="1wx2ceetuh7kg">
          <TrendingUp size={14} data-id="element-448" data-mp="1s498tua4459y" />
          Most Important Metric
        </div>
        <h3 className="text-3xl font-black mb-4" data-id="element-449" data-mp="1n7935kh6d4jd">The Retention Benchmark</h3>
        <p className="text-white/90 leading-relaxed mb-6" data-id="element-450" data-mp="1i97jaxbxd16u">
          TikTok distributes in waves. A video gets shown to a small test batch.
          If they watch to the end, it gets shown to a bigger batch.{' '}
          <strong className="text-white" data-id="element-451" data-mp="2axd6dqqgb29u">This compounds.</strong>
        </p>

        <div className="bg-white/15 backdrop-blur-sm rounded-2xl p-6 mb-6 border border-white/20" data-id="element-452" data-mp="25wfmn9psm068">
          <p className="text-sm uppercase tracking-wider text-white/70 font-bold mb-2" data-id="element-453" data-mp="21v3x146x5ey1">
            Target
          </p>
          <p className="text-4xl md:text-5xl font-black mb-2" data-id="element-454" data-mp="ujn0cefru3xk">42%+</p>
          <p className="text-white/90" data-id="element-455" data-mp="qfnmy4psfl8f">full video completion rate</p>
          <p className="text-sm text-white/70 mt-3" data-id="element-456" data-mp="ry5ihe3zzpc6">
            Below 42%, distribution waves stop. Above it, they compound.
          </p>
        </div>

        <h4 className="font-bold mb-3 text-white" data-id="element-457" data-mp="wwgv1wlogdy3">Practical implications:</h4>
        <ul className="space-y-3 mb-6" data-id="element-458" data-mp="hyogp7rv9vlh">
          <li className="flex items-start gap-3 text-white/90" data-id="element-459" data-mp="i1stgtjedznr">
            <span className="font-black text-white" data-id="element-460" data-mp="mxhrutjolaih">1.</span>
            <span data-id="element-461" data-mp="97o3ecc38s9a">
              First <strong className="text-white" data-id="element-462" data-mp="96czmcin7ki6">3 seconds must hook</strong>{' '}
              (stop the scroll)
            </span>
          </li>
          <li className="flex items-start gap-3 text-white/90" data-id="element-463" data-mp="e07i5cmihtfo">
            <span className="font-black text-white" data-id="element-464" data-mp="3vfxfj6wzqzh8">2.</span>
            <span data-id="element-465" data-mp="481q62w9fc0h">
              Middle must move{' '}
              <strong className="text-white" data-id="element-466" data-mp="48kyqt00so1u">fast enough</strong> that dropping
              off feels like a loss
            </span>
          </li>
          <li className="flex items-start gap-3 text-white/90" data-id="element-467" data-mp="3qg1bx8s7ha27">
            <span className="font-black text-white" data-id="element-468" data-mp="3qhm4isuymixf">3.</span>
            <span data-id="element-469" data-mp="37s920zyodt1z">
              Last <strong className="text-white" data-id="element-470" data-mp="37rhd27zl2tko">3 seconds must earn</strong>{' '}
              the watch (payoff or pattern interrupt)
            </span>
          </li>
        </ul>

        <p className="text-white/90 leading-relaxed mb-4" data-id="element-471" data-mp="3gsp0tw4h4c0i">
          Slow middles kill videos that have great hooks.{' '}
          <strong className="text-white" data-id="element-472" data-mp="3brhsnvyf5atb">Cut ruthlessly.</strong>
        </p>
        <p className="text-white/80 text-sm leading-relaxed" data-id="element-473" data-mp="3qoscptp4np0n">
          Likes and comments matter, but only as downstream effects of
          retention. Retention is the root signal.
        </p>

        <div className="mt-6 pt-6 border-t border-white/20" data-id="element-474" data-mp="3bpp9ct0f16r">
          <p className="text-sm uppercase tracking-wider text-white/70 font-bold mb-2" data-id="element-475" data-mp="3vh20b32rsczr">
            3-Second Watch-Time Benchmark
          </p>
          <p className="text-white/90 leading-relaxed" data-id="element-476" data-mp="dbyn0v2nguo9">
            <strong className="text-white" data-id="element-477" data-mp="8cccwui4bujo">75–80%</strong> of viewers watching
            past the first 3 seconds = "viral-ready" format. Use this as the
            primary filter for what formats to scale.
          </p>
        </div>
      </section>

      {/* Daily Maintenance */}
      <PhaseCard phase="Daily" title="Maintenance (Forever)" color="lavender" icon={<Repeat size={24} data-id="element-479" data-mp="1to2i74874dov" />} data-id="element-478" data-mp="1op81q8xpb17x">
        <p className="text-warmBrown/80 leading-relaxed" data-id="element-480" data-mp="1tn9g4gk6mcd2">
          Warming up is not a one-time event. If you stop behaving like a human
          on the app (watching, liking, commenting), the account goes cold and
          performance drops.{' '}
          <strong className="text-warmBrown" data-id="element-481" data-mp="15yqak8siodoo">
            Treat daily feed engagement like brushing teeth.
          </strong>
        </p>
      </PhaseCard>

      {/* Comment Seeding */}
      <section className="bg-white rounded-3xl p-8 md:p-10 shadow-soft border border-warmBrown/5" data-id="element-482" data-mp="1arjcyq0ij9xl">
        <div className="flex items-start gap-4 mb-6" data-id="element-483" data-mp="d7ygbgv0hz3z">
          <div className="w-12 h-12 rounded-full bg-peach/10 text-peach flex items-center justify-center flex-shrink-0" data-id="element-484" data-mp="i8442ly5v1gs">
            <MessageSquare size={22} data-id="element-485" data-mp="ap4nsp5zxq1n" />
          </div>
          <div data-id="element-486" data-mp="5q0dtwb8zoa9">
            <h3 className="text-2xl font-black text-warmBrown mb-1" data-id="element-487" data-mp="5rl7zktnh57l">
              Comment Seeding
            </h3>
            <p className="text-warmBrown/60 text-sm" data-id="element-488" data-mp="q5ovyb198ru">
              Turning curiosity into conversions.
            </p>
          </div>
        </div>

        <p className="text-warmBrown/80 leading-relaxed mb-6" data-id="element-489" data-mp="3nw6ei29heqwx">
          When a video gains traction but isn't converting, the issue is often a{' '}
          <strong className="text-warmBrown" data-id="element-490" data-mp="3j4ocrbzmwmaw">
            lack of visible social proof
          </strong>{' '}
          in comments. Seed comments from secondary accounts.
        </p>

        <h4 className="font-bold text-warmBrown mb-3" data-id="element-491" data-mp="398bgq7gm9wcz">
          Effective seed comments:
        </h4>
        <div className="space-y-2 mb-6" data-id="element-492" data-mp="3474cgidonfb2">
          {['what app is this??', 'does this actually work?', 'omg I need to try this with my cat', 'my dog would literally be perfect for this', 'anyone used this consistently? results?'].map(comment => <div key={comment} className="bg-cream/60 rounded-xl px-4 py-3 text-warmBrown/80 italic border-l-4 border-peach/40" data-id="element-493" data-mp="s63x41a3xgay">
              "{comment}"
            </div>)}
        </div>

        <Callout color="sage" icon={<Sparkles size={18} data-id="element-495" data-mp="1fvy96gmlr0u5" />} title="Pro tip" data-id="element-494" data-mp="1fwr50mk0w5xi">
          Give Claude the hook of the video + your ICP + Pawchi description →
          generate an organic-sounding comment where the persona explains how
          the app helped them. This turns passive viewers into curious readers
          who then convert.
        </Callout>

        <p className="text-warmBrown font-bold mt-6 text-center" data-id="element-496" data-mp="11wylbb6wypz1">
          No comments = no curiosity = no conversions.
        </p>
      </section>
    </motion.article>;
}
function PostingGuidelinesTopic() {
  const slots = [{
    label: 'Morning',
    window: '8–10 AM',
    icon: <Sunrise size={20} data-id="element-497" data-mp="226zhxceic2za" />,
    note: 'Catches the early scroll before work or class.'
  }, {
    label: 'Afternoon',
    window: '1–3 PM',
    icon: <Sun size={20} data-id="element-498" data-mp="2b5l2te7gbu38" />,
    note: 'Midday break traffic — strong for slideshows.'
  }, {
    label: 'Evening',
    window: '7–9 PM',
    icon: <Moon size={20} data-id="element-499" data-mp="2fyxn5c53leq6" />,
    note: 'Peak session length. Save your best video for this slot.'
  }];
  const rules = [{
    title: 'No AI-generated content',
    body: 'No AI voiceovers, AI avatars, AI-written scripts read word for word, or AI-generated footage. The only AI in your video is the Pawchi transformation itself.'
  }, {
    title: 'Film it yourself',
    body: 'Real hands, real voice, real pet or plushie, real room. Stock footage and reposted clips get filtered out and will not count toward your payouts.'
  }, {
    title: 'No copyrighted or trademarked plushies',
    body: 'No Disney, Jellycat, Squishmallows, Sanrio, Pokémon, or any licensed character plush — on your Pawchi or anywhere in the frame.'
  }, {
    title: 'Edit natively where you can',
    body: 'Record and edit inside TikTok or Instagram when possible. Heavily externally edited videos often see weaker distribution on a young account.'
  }, {
    title: 'One companion, one account',
    body: 'Keep the same companion, handle, and voice across your posts. Consistency is what turns viewers into followers.'
  }];
  return <motion.article initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.4
  }} className="space-y-10" data-id="element-500" data-mp="2lrtjzyammqwq">
      {/* Intro */}
      <header data-id="element-501" data-mp="39hnvocj7m9fe">
        <div className="inline-flex items-center gap-2 bg-peach/10 text-peach px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider mb-4" data-id="element-502" data-mp="39he4ilmfhw84">
          <CalendarDays size={14} data-id="element-503" data-mp="34grh9518f4vq" />
          Posting Rules
        </div>
        <h2 className="text-3xl md:text-4xl font-black text-warmBrown mb-4" data-id="element-504" data-mp="3o5xndxcaztgh">
          Posting Guidelines
        </h2>
        <p className="text-warmBrown/80 text-lg leading-relaxed" data-id="element-505" data-mp="3t2xsa4xf2q60">
          Volume and authenticity are what make a UGC account work.{' '}
          <strong className="text-warmBrown" data-id="element-506" data-mp="3j59nsna0e4an">
            Three real videos a day, spread out, no AI.
          </strong>{' '}
          Everything below is a requirement, not a suggestion.
        </p>
      </header>

      {/* Cadence — the headline number */}
      <section className="bg-white rounded-3xl p-8 md:p-10 shadow-soft border border-warmBrown/5" data-id="element-507" data-mp="3a663xh30pkv3">
        <div className="flex flex-col md:flex-row md:items-center gap-6 md:gap-10 mb-8" data-id="element-508" data-mp="2vhrzj1pydocf">
          <div className="flex-shrink-0" data-id="element-509" data-mp="30fla06yah4ii">
            <p className="text-xs font-bold uppercase tracking-wider text-warmBrown/40 mb-2" data-id="element-510" data-mp="2mfitao1pwh4u">
              Daily Quota
            </p>
            <p className="text-6xl md:text-7xl font-black text-peach leading-none" data-id="element-511" data-mp="2rd25zjiroluo">
              3
            </p>
            <p className="text-warmBrown font-bold mt-2" data-id="element-512" data-mp="2jd5zyvzqllqy">videos per day</p>
          </div>
          <div className="md:border-l md:border-warmBrown/10 md:pl-10" data-id="element-513" data-mp="2efw34va0q7t3">
            <h3 className="text-2xl font-black text-warmBrown mb-2" data-id="element-514" data-mp="29n2w20r2undu">
              Spread them evenly
            </h3>
            <p className="text-warmBrown/80 leading-relaxed" data-id="element-515" data-mp="25lhmao9uap7v">
              Post roughly{' '}
              <strong className="text-warmBrown" data-id="element-516" data-mp="20o7s6vbi9pdp">
                4–6 hours apart, never back to back
              </strong>
              . Three videos dumped in one sitting compete with each other for
              the same test audience — spacing them out gives each one its own
              distribution window.
            </p>
          </div>
        </div>

        <p className="text-xs font-bold uppercase tracking-wider text-warmBrown/40 mb-3" data-id="element-517" data-mp="3l2rj0s4bzmen">
          Suggested slots
        </p>
        <div className="grid sm:grid-cols-3 gap-3" data-id="element-518" data-mp="3h2hdthod500u">
          {slots.map(slot => <div key={slot.label} className="bg-cream/60 rounded-2xl p-5 flex flex-col" data-id="element-519" data-mp="12u6nj2f6ygsp">
              <div className="flex items-center gap-2 text-peach mb-3" data-id="element-520" data-mp="17r6wbl3fdxni">
                {slot.icon}
                <p className="text-xs font-bold uppercase tracking-wider" data-id="element-521" data-mp="1ck02mdejle1p">
                  {slot.label}
                </p>
              </div>
              <p className="text-xl font-black text-warmBrown mb-2" data-id="element-522" data-mp="jusv4ox41e4b">
                {slot.window}
              </p>
              <p className="text-sm text-warmBrown/70 leading-relaxed mt-auto" data-id="element-523" data-mp="otdteissxnq4">
                {slot.note}
              </p>
            </div>)}
        </div>

        <Callout color="peach" icon={<Clock size={16} data-id="element-525" data-mp="xv3lzryf6sph" />} title="Missed a slot?" data-id="element-524" data-mp="sxtwydey0j26">
          Post it late rather than doubling up later. Consistency across days
          matters more than hitting exactly three on any single day.
        </Callout>
      </section>

      {/* CTA + demo requirement */}
      <section className="bg-white rounded-3xl p-8 md:p-10 shadow-soft border border-warmBrown/5" data-id="element-526" data-mp="29bk0nj25h5ba">
        <div className="flex items-start gap-4 mb-6" data-id="element-527" data-mp="99c45s81u6nd">
          <div className="w-12 h-12 rounded-full bg-peach/10 text-peach flex items-center justify-center flex-shrink-0" data-id="element-528" data-mp="554glydbuwqq">
            <Megaphone size={22} data-id="element-529" data-mp="j4vxq7z54t8y" />
          </div>
          <div data-id="element-530" data-mp="e62j2c84aw77">
            <p className="text-xs font-bold uppercase tracking-wider text-peach mb-1" data-id="element-531" data-mp="e7m40g4pxvfb">
              Every Single Video
            </p>
            <h3 className="text-2xl font-black text-warmBrown mb-1" data-id="element-532" data-mp="3mkb9bdn63aw7">
              Always Include a CTA and App Demo
            </h3>
            <p className="text-warmBrown/60 text-sm" data-id="element-533" data-mp="6jhk29taj3v">
              A video with no demo and no CTA gets views but zero installs.
            </p>
          </div>
        </div>

        <p className="text-warmBrown/80 leading-relaxed mb-6" data-id="element-534" data-mp="3rjnrhl33ftsg">
          Viewers need to see the app and be told what to do next. Every post —
          including slideshows — needs{' '}
          <strong className="text-warmBrown" data-id="element-535" data-mp="2yup86kn8illk">
            at least 2–3 seconds of real Pawchi screen footage
          </strong>{' '}
          and{' '}
          <strong className="text-warmBrown" data-id="element-536" data-mp="1j5r0s1lbl7v7">one clear call to action</strong>.
        </p>

        <div className="grid md:grid-cols-2 gap-4 mb-6" data-id="element-537" data-mp="15em85jgddfud">
          <div className="bg-cream/60 rounded-2xl p-6" data-id="element-538" data-mp="15bzur36ss648">
            <div className="flex items-center gap-2 text-peach mb-3" data-id="element-539" data-mp="19gpnij65t4kx">
              <Smartphone size={18} data-id="element-540" data-mp="1x5ies2bu6o97" />
              <p className="text-xs font-bold uppercase tracking-wider" data-id="element-541" data-mp="1x6jyswatyl32">
                The demo
              </p>
            </div>
            <ul className="space-y-2" data-id="element-542" data-mp="221zbvm10kcyf">
              {['Show your companion animated in the app', 'Show one habit or mood check-in being completed', 'Screen record it — do not describe it', 'Keep it short: 2–3 seconds is enough'].map(item => <li key={item} className="flex items-start gap-2.5 text-sm text-warmBrown/80 leading-relaxed" data-id="element-543" data-mp="hp1f27qi527d">
                  <CheckCircle2 size={16} className="text-peach mt-0.5 flex-shrink-0" data-id="element-544" data-mp="18ch72cophvzl" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="bg-cream/60 rounded-2xl p-6" data-id="element-545" data-mp="ufc4wns45h9m">
            <div className="flex items-center gap-2 text-peach mb-3" data-id="element-546" data-mp="ugwz2caimy6y">
              <Link2 size={18} data-id="element-547" data-mp="1s19h63fwgqd4" />
              <p className="text-xs font-bold uppercase tracking-wider" data-id="element-548" data-mp="1s4dqtgc4web6">
                The CTA
              </p>
            </div>
            <ul className="space-y-2" data-id="element-549" data-mp="1ic7xo3a5bque">
              {['Say it out loud or put it in on-screen text', 'Place it in the last 2–3 seconds', 'Point to your bio link, never a raw URL', 'Pin a comment with the CTA after posting'].map(item => <li key={item} className="flex items-start gap-2.5 text-sm text-warmBrown/80 leading-relaxed" data-id="element-550" data-mp="261k5oztqlsv4">
                  <CheckCircle2 size={16} className="text-peach mt-0.5 flex-shrink-0" data-id="element-551" data-mp="2icbf9ewfzo43" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <p className="text-xs font-bold uppercase tracking-wider text-warmBrown/40 mb-3" data-id="element-552" data-mp="2sc2cvpgauj8e">
          CTAs that work
        </p>
        <div className="space-y-2" data-id="element-553" data-mp="2wai4k6nbsfs5">
          {['"Link in bio if you want your own Pawchi."', '"Comment your pet and I\'ll show you what it looks like."', '"Upload your pet and see what it becomes."', '"If you have a plushie you love, you need to try this."'].map(cta => <div key={cta} className="bg-peach/10 rounded-xl px-4 py-3 text-warmBrown/80 italic border-l-4 border-peach/40" data-id="element-554" data-mp="3g14uwyeuie3f">
              {cta}
            </div>)}
        </div>

        <Callout color="coral" icon={<AlertTriangle size={16} data-id="element-556" data-mp="vkhx8gpg7tww" />} title="Do not end cold" data-id="element-555" data-mp="qk3tvbysl857">
          Cutting straight from the reveal to the end of the video is the most
          common mistake creators make. The delight is the hook —{' '}
          <strong data-id="element-557" data-mp="lndbuj3fg2h5">the CTA is what converts it</strong>.
        </Callout>
      </section>

      {/* No AI — hardest rule, own treatment */}
      <section className="bg-warmBrown rounded-3xl p-8 md:p-10 text-cream" data-id="element-558" data-mp="19eiqiuxmsopv">
        <div className="flex items-start gap-4 mb-4" data-id="element-559" data-mp="1eapvoli7dw6r">
          <div className="w-12 h-12 rounded-full bg-coral/20 text-coral flex items-center justify-center flex-shrink-0" data-id="element-560" data-mp="zmwkre42bhui">
            <Bot size={22} data-id="element-561" data-mp="14kekcdw6wkpu" />
          </div>
          <div data-id="element-562" data-mp="14j3e87f9v0vk">
            <p className="text-xs font-bold uppercase tracking-wider text-coral mb-1" data-id="element-563" data-mp="1sbaidsr8oc5j">
              Zero Tolerance
            </p>
            <h3 className="text-2xl font-black mb-1" data-id="element-564" data-mp="1x2sikelfu8pg">No AI-Generated Content</h3>
            <p className="text-cream/60 text-sm" data-id="element-565" data-mp="3hrmh3waybjdy">
              The Pawchi transformation is the only AI in your video.
            </p>
          </div>
        </div>

        <p className="text-cream/85 leading-relaxed mb-6" data-id="element-566" data-mp="3cr8l5cmmjzwa">
          Pawchi content converts because it feels like a real person showing
          you something they love. AI voiceovers, AI avatars, and generated
          footage kill that instantly — and viewers spot it in under a second.
        </p>

        <ul className="space-y-3" data-id="element-567" data-mp="2yv4t9pz843mz">
          {['No AI voiceovers or text-to-speech narration in your own voice slot', 'No AI avatars, faceless generated presenters, or synthetic footage', 'No AI-written scripts read word for word', 'No AI-upscaled or generated pet or plushie imagery'].map(item => <li key={item} className="flex items-start gap-3" data-id="element-568" data-mp="n26b9rkwc0px">
              <XCircle size={18} className="text-coral mt-0.5 flex-shrink-0" data-id="element-569" data-mp="j2p6l0dan7lt" />
              <span className="text-cream/85 leading-relaxed" data-id="element-570" data-mp="3bwmiaxr33i9r">{item}</span>
            </li>)}
        </ul>
      </section>

      {/* Remaining rules */}
      <section className="bg-white rounded-3xl p-8 md:p-10 shadow-soft border border-warmBrown/5" data-id="element-571" data-mp="3gtw6yb6nfpwj">
        <div className="flex items-start gap-4 mb-6" data-id="element-572" data-mp="3lvlj5u5ly9m7">
          <div className="w-12 h-12 rounded-full bg-sage/10 text-sage flex items-center justify-center flex-shrink-0" data-id="element-573" data-mp="3pwx9y307x0vz">
            <CheckCircle2 size={22} data-id="element-574" data-mp="2t77o9n9tftev" />
          </div>
          <div data-id="element-575" data-mp="2y593fx44f8l2">
            <h3 className="text-2xl font-black text-warmBrown mb-1" data-id="element-576" data-mp="2y4pw1ac3k2la">
              The Rest of the Rules
            </h3>
            <p className="text-warmBrown/60 text-sm" data-id="element-577" data-mp="325rwfuhr2kou">
              Break these and your videos will not count toward payouts.
            </p>
          </div>
        </div>

        <div className="space-y-4" data-id="element-578" data-mp="2afwtuw4vsyi8">
          {rules.map(rule => <div key={rule.title} className="bg-cream/60 rounded-2xl p-5" data-id="element-579" data-mp="2adu8wqil5vkd">
              <h4 className="font-bold text-warmBrown mb-1" data-id="element-580" data-mp="2efp91ros62wk">{rule.title}</h4>
              <p className="text-sm text-warmBrown/75 leading-relaxed" data-id="element-581" data-mp="26wodpto4vfka">
                {rule.body}
              </p>
            </div>)}
        </div>
      </section>

      {/* Next steps */}
      <Callout color="lavender" icon={<Lightbulb size={18} data-id="element-583" data-mp="1xyvy0oei25wd" />} title="What to actually post" data-id="element-582" data-mp="1xvzzoyyqpf7e">
        Head to <strong data-id="element-584" data-mp="1t02hso7tw0si">The Viral Formula</strong> for the four formats that
        work, then <strong data-id="element-585" data-mp="1o0g4kes02kjp">Hooks &amp; Viral Angles</strong> for openers you can
        use across your three daily slots.
      </Callout>
    </motion.article>;
}
function ViralFormulaTopic() {
  const ingredients = [{
    label: 'Viral Feature',
    title: 'Real pet photo → animated AI sprite',
    desc: 'A "reveal moment" — identical in structure to face ratings, food scanners, or body analysis apps that generate millions of views. The reveal IS the ad.',
    icon: <Wand2 size={22} data-id="element-586" data-mp="1090yqc10ll3p" />,
    color: 'peach' as const
  }, {
    label: 'Core Desire',
    title: 'Love + identity + nostalgia',
    desc: 'Love for a real pet, desire for a self-care identity, and Tamagotchi nostalgia — three of the strongest emotional pulls online right now.',
    icon: <Heart size={22} data-id="element-587" data-mp="2qmika1i3llgh" />,
    color: 'coral' as const
  }, {
    label: 'Shareable Output',
    title: 'The animated pet sprite',
    desc: "The animated pet sprite, the pet's 'stats,' and the transformation itself — all inherently shareable across stories, group chats, and feeds.",
    icon: <Share2 size={22} data-id="element-588" data-mp="2lnp584n5xme7" />,
    color: 'lavender' as const
  }];
  const formats = [{
    number: 1,
    priority: 'Highest Priority',
    title: 'The Transformation Reveal',
    structure: 'Real pet photo (before) → dramatic transition → animated Pawchi sprite (after)',
    hooks: ['"I turned my cat into a Tamagotchi... [she has opinions]"', '"POV you upload your dog\'s photo to this app"', '"This AI turned my actual cat into an animated version of herself and I\'m not okay"'],
    why: 'The reveal creates genuine delight and "I want to see mine" impulse. The comment section fills with "do mine!" requests organically. Highest-conversion format.',
    icon: <Wand2 size={22} data-id="element-589" data-mp="253rhfflcplbq" />,
    color: 'peach' as const
  }, {
    number: 2,
    priority: 'Self-Care Angle',
    title: 'The Accountability Loop',
    structure: 'Morning routine or habit check-in, showing how completing habits makes the pet thrive',
    hooks: ['"My virtual pet died because I didn\'t drink water [I deserved it]"', '"Day 14 of letting my pet motivate my self-care routine"', '"What happens to your Pawchi when you skip your habits for 3 days"'],
    why: 'Demonstrates the core gameplay loop and the emotional stakes (pet declining hits hard). Creates relatability for anyone who struggles with habits.',
    icon: <Heart size={22} data-id="element-590" data-mp="oprjub9za7rn" />,
    color: 'coral' as const
  }, {
    number: 3,
    priority: 'Pet Identity',
    title: 'Slideshows',
    structure: '"If you\'re the kind of person who [trait]... your pet would be a [species/type]" — or — "What your self-care score says about your pet\'s personality"',
    hooks: [],
    why: 'Identity labeling creates instant engagement. People tag friends, share to stories, comment with their own results.',
    icon: <Tags size={22} data-id="element-591" data-mp="1xa59oqzzkp7l" />,
    color: 'lavender' as const
  }, {
    number: 4,
    priority: 'App Demo',
    title: 'Screen Recording Demo',
    structure: 'Screen record of onboarding / pet customization with voiceover or text captions',
    hooks: ['"Okay this app genuinely got me to drink water for the first time in a week"'],
    why: "Shows the product in the most authentic, low-production way. Feels user-generated even when it isn't.",
    icon: <Monitor size={22} data-id="element-592" data-mp="2l1u6ajjubzuc" />,
    color: 'sage' as const
  }];
  const colorMap = {
    peach: {
      bg: 'bg-peach/10',
      text: 'text-peach',
      solid: 'bg-peach'
    },
    coral: {
      bg: 'bg-coral/10',
      text: 'text-coral',
      solid: 'bg-coral'
    },
    lavender: {
      bg: 'bg-lavender/10',
      text: 'text-lavender',
      solid: 'bg-lavender'
    },
    sage: {
      bg: 'bg-sage/10',
      text: 'text-sage',
      solid: 'bg-sage'
    }
  };
  return <motion.article initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.4
  }} className="space-y-10" data-id="element-593" data-mp="s46qw2ug7bmn">
      {/* Intro */}
      <header data-id="element-594" data-mp="ic0y4qwdgq6e">
        <div className="inline-flex items-center gap-2 bg-peach/10 text-peach px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider mb-4" data-id="element-595" data-mp="df0radrp7je8">
          <Flame size={14} data-id="element-596" data-mp="1av6i7apf0xj3" />
          Growth Strategy
        </div>
        <h2 className="text-3xl md:text-4xl font-black text-warmBrown mb-4" data-id="element-597" data-mp="1636hhg1iu0lg">
          The Viral Formula for Pawchi
        </h2>
        <p className="text-warmBrown/80 text-lg leading-relaxed" data-id="element-598" data-mp="efbtod1fkqmj">
          Every viral product on TikTok and Reels follows the same recipe.{' '}
          <strong className="text-warmBrown" data-id="element-599" data-mp="5ffaus1q2lze">
            Pawchi has all three ingredients.
          </strong>{' '}
          Here's how to use them.
        </p>
      </header>

      {/* Formula equation */}
      <section className="bg-white rounded-3xl p-8 md:p-10 shadow-soft border border-warmBrown/5" data-id="element-600" data-mp="y4dtrrdo5s5r">
        <p className="text-xs font-bold uppercase tracking-wider text-warmBrown/40 mb-6" data-id="element-601" data-mp="125fsm73oc277">
          The Formula
        </p>
        <div className="flex flex-wrap items-center gap-3 md:gap-4 text-warmBrown" data-id="element-602" data-mp="o4va7c1o88e8">
          <span className="px-4 py-2 bg-peach/10 text-peach rounded-xl font-bold text-sm md:text-base" data-id="element-603" data-mp="t4hxkeb7r50r">
            Viral Feature
          </span>
          <Plus size={18} className="text-warmBrown/40" data-id="element-604" data-mp="38uugzi6zcbf9" />
          <span className="px-4 py-2 bg-coral/10 text-coral rounded-xl font-bold text-sm md:text-base" data-id="element-605" data-mp="3dvigks99y0l3">
            Core Human Desire
          </span>
          <Plus size={18} className="text-warmBrown/40" data-id="element-606" data-mp="36du06k7fpcrs" />
          <span className="px-4 py-2 bg-lavender/10 text-lavender rounded-xl font-bold text-sm md:text-base" data-id="element-607" data-mp="31bl77nukaapo">
            Shareable Output
          </span>
          <Equal size={18} className="text-warmBrown/40" data-id="element-608" data-mp="3adb95nm2ks1p" />
          <span className="px-4 py-2 bg-warmBrown text-cream rounded-xl font-bold text-sm md:text-base" data-id="element-609" data-mp="3adufs869ru0f">
            Organic Growth Machine
          </span>
        </div>
      </section>

      {/* Three ingredients */}
      <section data-id="element-610" data-mp="2ik23tfwmkun4">
        <h3 className="text-2xl font-black text-warmBrown mb-6" data-id="element-611" data-mp="2ikbyhgsm7pz5">
          How Pawchi checks every box
        </h3>
        <div className="grid md:grid-cols-3 gap-4" data-id="element-612" data-mp="2rn38dc5uedoo">
          {ingredients.map(item => {
          const c = colorMap[item.color];
          return <div key={item.label} className="bg-white rounded-3xl p-6 shadow-soft border border-warmBrown/5 flex flex-col" data-id="element-613" data-mp="23vfsdpa4cn16">
                <div className={`w-12 h-12 rounded-full ${c.bg} ${c.text} flex items-center justify-center mb-4`} data-id="element-614" data-mp="vergqagptinl">
                  {item.icon}
                </div>
                <p className={`text-xs font-bold uppercase tracking-wider ${c.text} mb-1`} data-id="element-615" data-mp="154kpz4tdxloo">
                  {item.label}
                </p>
                <h4 className="font-black text-warmBrown mb-2 leading-tight" data-id="element-616" data-mp="1e3pqggoibp3h">
                  {item.title}
                </h4>
                <p className="text-sm text-warmBrown/70 leading-relaxed" data-id="element-617" data-mp="1a2cgpvian1ra">
                  {item.desc}
                </p>
              </div>;
        })}
        </div>
      </section>

      {/* Reveal mechanic */}
      <section className="bg-gradient-to-br from-peach to-coral rounded-3xl p-8 md:p-10 text-white" data-id="element-618" data-mp="1j1r76uygncbs">
        <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider mb-4" data-id="element-619" data-mp="3pvuyl58kwme6">
          <Sparkles size={14} data-id="element-620" data-mp="20e7hnwuoc4v4" />
          Highest Priority
        </div>
        <h3 className="text-3xl font-black mb-4" data-id="element-621" data-mp="25ciwklztt5k7">The Reveal Mechanic</h3>
        <p className="text-white/90 leading-relaxed mb-6" data-id="element-622" data-mp="1qn35t60ap04i">
          The single most viral moment in Pawchi is the transformation: user
          uploads real pet photo → Pawchi generates animated sprite. This is
          your{' '}
          <strong className="text-white" data-id="element-623" data-mp="1hm58f6kd3quw">UMax "face rating reveal,"</strong>{' '}
          your <strong className="text-white" data-id="element-624" data-mp="1mm150kqqcg0f">Cal AI "calorie reveal."</strong>
        </p>
        <div className="bg-white/15 backdrop-blur-sm rounded-2xl p-6 border border-white/20 mb-6" data-id="element-625" data-mp="17oh35mp4r0yh">
          <p className="font-bold text-lg leading-snug" data-id="element-626" data-mp="1cn24xqk15sp1">
            Every ad creative, every organic video, every influencer brief must
            center on this reveal.{' '}
            <span className="block mt-2" data-id="element-627" data-mp="320fd5qv9k0vf">
              Do not show features. Show the reveal.
            </span>
          </p>
        </div>
        <div data-id="element-628" data-mp="35kfucjodo9r1">
          <p className="text-sm uppercase tracking-wider text-white/70 font-bold mb-2" data-id="element-629" data-mp="35l7biph8a4xs">
            Why it works
          </p>
          <p className="text-white/90 leading-relaxed" data-id="element-630" data-mp="30jrtl6ackejm">
            TikTok and Reels are dopamine delivery systems. The reveal gives
            viewers a reason to watch to the end, and a reason to comment{' '}
            <em className="text-white" data-id="element-631" data-mp="2rmhef9ues59f">("omg do mine," "what is this app")</em>.
            Both behaviors drive algorithmic distribution.
          </p>
        </div>
      </section>

      {/* Four formats intro */}
      <section data-id="element-632" data-mp="3ekufnj1cdouj">
        <h3 className="text-2xl md:text-3xl font-black text-warmBrown mb-2" data-id="element-633" data-mp="3ekcb7z4j04bj">
          The Four Organic Formats
        </h3>
        <p className="text-warmBrown/70 leading-relaxed mb-8" data-id="element-634" data-mp="3ai7hl0e2v7ow">
          Ranked by priority. Mix and match these for your weekly content
          schedule.
        </p>

        <div className="space-y-5" data-id="element-635" data-mp="65aocpk8egi4">
          {formats.map(format => {
          const c = colorMap[format.color];
          return <article key={format.number} className="bg-white rounded-3xl p-8 shadow-soft border border-warmBrown/5" data-id="element-636" data-mp="1otddakw6jys2">
                <div className="flex items-start gap-4 mb-5" data-id="element-637" data-mp="1xs7fqrw6zjdj">
                  <div className={`w-14 h-14 rounded-2xl ${c.solid} text-white flex items-center justify-center flex-shrink-0 font-black text-xl`} data-id="element-638" data-mp="1xutmipb9duup">
                    {format.number}
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-639" data-mp="2copu2lzlajgv">
                    <p className={`text-xs font-bold uppercase tracking-wider ${c.text} mb-1`} data-id="element-640" data-mp="2cneqam659bpr">
                      Format {format.number} · {format.priority}
                    </p>
                    <h4 className="text-xl md:text-2xl font-black text-warmBrown" data-id="element-641" data-mp="2qho33b4yga2w">
                      {format.title}
                    </h4>
                  </div>
                </div>

                <div className="mb-5" data-id="element-642" data-mp="2ht8sibetpp3r">
                  <p className="text-xs font-bold uppercase tracking-wider text-warmBrown/40 mb-2" data-id="element-643" data-mp="2hs7cdsiyacf6">
                    Structure
                  </p>
                  <p className="text-warmBrown/80 leading-relaxed" data-id="element-644" data-mp="2rj22x938by6f">
                    {format.structure}
                  </p>
                </div>

                {format.hooks.length > 0 && <div className="mb-5" data-id="element-645" data-mp="1yuec6xzpoglh">
                    <p className="text-xs font-bold uppercase tracking-wider text-warmBrown/40 mb-3" data-id="element-646" data-mp="1yvfp780afd5u">
                      Hook options
                    </p>
                    <div className="space-y-2" data-id="element-647" data-mp="28skevhtcdqre">
                      {format.hooks.map(hook => <div key={hook} className={`bg-cream/60 rounded-xl px-4 py-3 text-warmBrown/80 italic border-l-4 ${c.text.replace('text-', 'border-')}/40`} data-id="element-648" data-mp="23t7qutqqidn8">
                          {hook}
                        </div>)}
                    </div>
                  </div>}

                <div className={`${c.bg} rounded-2xl p-5`} data-id="element-649" data-mp="3rr8kgcm8gdai">
                  <div className="flex items-center gap-2 mb-2" data-id="element-650" data-mp="3rst9xntox61i">
                    <Lightbulb size={16} className={c.text} data-id="element-651" data-mp="3dssbef0weap7" />
                    <p className={`font-bold text-sm ${c.text}`} data-id="element-652" data-mp="3htc5tau3707n">
                      Why it works
                    </p>
                  </div>
                  <p className="text-warmBrown/80 text-sm leading-relaxed" data-id="element-653" data-mp="9etu8z4xt2ja">
                    {format.why}
                  </p>
                </div>
              </article>;
        })}
        </div>
      </section>
    </motion.article>;
}
function HooksTopic() {
  const categories = [{
    label: 'Emotional / Attachment',
    icon: <HeartHandshake size={22} data-id="element-654" data-mp="scmyq5v7lkis" />,
    color: 'coral' as const,
    hooks: ['"I cried when I saw my cat as an animated character [she has her exact markings]"', '"This app turned my dead dog into a living animated version of him [I\'m not okay]"', '"POV: your actual pet becomes your virtual self-care companion"']
  }, {
    label: 'Accountability / Consequence',
    icon: <AlertCircle size={22} data-id="element-655" data-mp="xxvu2hp8orte" />,
    color: 'peach' as const,
    hooks: ['"My virtual pet literally got sick because I didn\'t sleep enough [I deserved it]"', '"The only thing that made me actually do my morning routine is not wanting to let my cat down"', '"What happens to your Pawchi when you skip days [warning: sad]"']
  }, {
    label: 'Curiosity / Transformation',
    icon: <HelpCircle size={22} data-id="element-656" data-mp="f8pciy06m696" />,
    color: 'lavender' as const,
    hooks: ['"Watch me turn my dog into a Tamagotchi [AI did this in 10 seconds]"', '"I uploaded my cat\'s photo and now I have to take care of her digitally"', '"This app is literally Tamagotchi but your actual pet [how is this free]"']
  }, {
    label: 'Nostalgia',
    icon: <Gamepad2 size={22} data-id="element-657" data-mp="3mcvxwwf91s7o" />,
    color: 'sage' as const,
    hooks: ['"Tamagotchi but it\'s YOUR actual pet and it\'s connected to your real habits"', '"Grew up with Tamagotchis, now I have one but it looks exactly like my dog"', '"POV: it\'s 2006 and your Tamagotchi is your actual cat"']
  }, {
    label: 'Identity',
    icon: <Fingerprint size={22} data-id="element-658" data-mp="33luxs52e7qmj" />,
    color: 'peach' as const,
    hooks: ['"Self-care apps never worked for me until my cat\'s wellbeing depended on it"', '"I\'m a terrible habit person but I\'ve been consistent for 30 days because of this app"', '"Turns out the only accountability system I needed was a virtual version of my own pet"']
  }];
  const colorMap = {
    peach: {
      bg: 'bg-peach/10',
      text: 'text-peach',
      border: 'border-peach/40'
    },
    coral: {
      bg: 'bg-coral/10',
      text: 'text-coral',
      border: 'border-coral/40'
    },
    lavender: {
      bg: 'bg-lavender/10',
      text: 'text-lavender',
      border: 'border-lavender/40'
    },
    sage: {
      bg: 'bg-sage/10',
      text: 'text-sage',
      border: 'border-sage/40'
    }
  };
  const commentBait = ['Flash a leaderboard showing a rival pet beating the user\'s pet (provokes "how do you compete?" comments)', 'Show a strange/unexpected pet name or stat combination', 'Show the pet\'s "disapproval" animation', 'Anything that makes viewers feel they saw something and need to comment about it'];
  return <motion.article initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.4
  }} className="space-y-10" data-id="element-659" data-mp="mqqby1qwbxfy">
      {/* Intro */}
      <header data-id="element-660" data-mp="1aj6uedejprfs">
        <div className="inline-flex items-center gap-2 bg-peach/10 text-peach px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider mb-4" data-id="element-661" data-mp="1aincgwowb31r">
          <Anchor size={14} data-id="element-662" data-mp="1p53z36n0yawy" />
          Hook Library
        </div>
        <h2 className="text-3xl md:text-4xl font-black text-warmBrown mb-4" data-id="element-663" data-mp="1p2q2gtcp4qna">
          Hooks &amp; Viral Angles
        </h2>
        <p className="text-warmBrown/80 text-lg leading-relaxed" data-id="element-664" data-mp="1f6wuzodu3ncd">
          The first 3 seconds decide everything. Swipe these{' '}
          <strong className="text-warmBrown" data-id="element-665" data-mp="1k4onajie5bh3">
            highest-leverage hook angles
          </strong>{' '}
          for Pawchi, then customize them with details about your specific pet.
        </p>
      </header>

      {/* Hook categories */}
      <section className="space-y-5" data-id="element-666" data-mp="1a9ek3sg9ay1q">
        {categories.map(cat => {
        const c = colorMap[cat.color];
        return <article key={cat.label} className="bg-white rounded-3xl p-8 shadow-soft border border-warmBrown/5" data-id="element-667" data-mp="11egnaa9zn154">
              <div className="flex items-center gap-4 mb-5" data-id="element-668" data-mp="mk2airh0onyw">
                <div className={`w-12 h-12 rounded-full ${c.bg} ${c.text} flex items-center justify-center flex-shrink-0`} data-id="element-669" data-mp="rg0xqbqlzzxq">
                  {cat.icon}
                </div>
                <h3 className="text-xl md:text-2xl font-black text-warmBrown" data-id="element-670" data-mp="sc9im1nze2ql">
                  {cat.label} Hooks
                </h3>
              </div>

              <div className="space-y-2" data-id="element-671" data-mp="11c63ds792hgd">
                {cat.hooks.map(hook => <div key={hook} className={`bg-cream/60 rounded-xl px-4 py-3 text-warmBrown/80 italic border-l-4 ${c.border}`} data-id="element-672" data-mp="16biljzn6f0cm">
                    {hook}
                  </div>)}
              </div>
            </article>;
      })}
      </section>

      {/* Hook structure formula */}
      <section className="bg-gradient-to-br from-peach to-coral rounded-3xl p-8 md:p-10 text-white" data-id="element-673" data-mp="1kzlwlng2t28a">
        <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider mb-4" data-id="element-674" data-mp="1ozxckmxhuedf">
          <Sparkles size={14} data-id="element-675" data-mp="3ek6ypoatgzbj" />
          The Formula
        </div>
        <h3 className="text-3xl font-black mb-4" data-id="element-676" data-mp="39kaupp24d7vz">Hook Structure Formula</h3>
        <p className="text-white/90 leading-relaxed mb-6" data-id="element-677" data-mp="39m5idb4rze3r">
          For Pawchi specifically, the highest-performing hook pattern is:
        </p>

        <div className="flex flex-wrap items-center gap-2 md:gap-3 mb-8" data-id="element-678" data-mp="30k4mahla2y3o">
          <span className="px-4 py-2 bg-white/20 backdrop-blur-sm rounded-xl font-bold text-sm md:text-base border border-white/30" data-id="element-679" data-mp="13zlgnkc40br">
            Specific personal detail
          </span>
          <Plus size={18} className="text-white/60" data-id="element-680" data-mp="3taeaxma8dm3s" />
          <span className="px-4 py-2 bg-white/20 backdrop-blur-sm rounded-xl font-bold text-sm md:text-base border border-white/30" data-id="element-681" data-mp="3og0jfuyovz4e">
            Surprising outcome
          </span>
          <Plus size={18} className="text-white/60" data-id="element-682" data-mp="ksgnegmpevi8" />
          <span className="px-4 py-2 bg-white/20 backdrop-blur-sm rounded-xl font-bold text-sm md:text-base border border-white/30" data-id="element-683" data-mp="ku1l2f4beukb">
            Implicit challenge / FOMO
          </span>
        </div>

        <div className="bg-white/15 backdrop-blur-sm rounded-2xl p-6 border border-white/20" data-id="element-684" data-mp="z0394gjdw1rz">
          <p className="text-sm uppercase tracking-wider text-white/70 font-bold mb-3" data-id="element-685" data-mp="13yo8yeuq4jfw">
            Example
          </p>
          <p className="text-white/95 leading-relaxed italic" data-id="element-686" data-mp="u6s9p0gwina3">
            "I uploaded my{' '}
            <strong className="text-white not-italic bg-white/20 px-1.5 py-0.5 rounded" data-id="element-687" data-mp="g7itw1wlxv6n">
              grey tabby's photo
            </strong>{' '}
            [specific] and she now has{' '}
            <strong className="text-white not-italic bg-white/20 px-1.5 py-0.5 rounded" data-id="element-688" data-mp="76kopgafnhmh">
              her exact markings in the app
            </strong>{' '}
            [surprising] and{' '}
            <strong className="text-white not-italic bg-white/20 px-1.5 py-0.5 rounded" data-id="element-689" data-mp="b9zeuzs35edn">
              my water intake has never been higher
            </strong>{' '}
            [FOMO/outcome]"
          </p>
        </div>
      </section>

      {/* Comment bait */}
      <section className="bg-white rounded-3xl p-8 md:p-10 shadow-soft border border-warmBrown/5" data-id="element-690" data-mp="3q4rf1i7tt8bj">
        <div className="flex items-start gap-4 mb-5" data-id="element-691" data-mp="3m47j2hyzoaqz">
          <div className="w-12 h-12 rounded-full bg-lavender/10 text-lavender flex items-center justify-center flex-shrink-0" data-id="element-692" data-mp="3odiug2vmh57">
            <MessageSquare size={22} data-id="element-693" data-mp="3v29od9pr9pk2" />
          </div>
          <div data-id="element-694" data-mp="dmt80dicfgc2">
            <h3 className="text-2xl font-black text-warmBrown mb-1" data-id="element-695" data-mp="dmbehon2fg7u">
              Comment Bait Elements
            </h3>
            <p className="text-warmBrown/60 text-sm" data-id="element-696" data-mp="8moqql9m2hks">
              Hide something that provokes a reaction.
            </p>
          </div>
        </div>

        <p className="text-warmBrown/80 leading-relaxed mb-6" data-id="element-697" data-mp="ml54gw5w58cf">
          Hide something in the video that provokes comments. It{' '}
          <strong className="text-warmBrown" data-id="element-698" data-mp="2oe2ukk8a9mto">
            does not need to be related to the app
          </strong>
          :
        </p>

        <ul className="space-y-3 mb-6" data-id="element-699" data-mp="2jhm3pi9p8ucw">
          {commentBait.map(item => <li key={item} className="flex items-start gap-3" data-id="element-700" data-mp="2ltofap372z41">
              <span className="mt-2 w-2 h-2 rounded-full bg-lavender flex-shrink-0" data-id="element-701" data-mp="2pvi9ceivx4v8"></span>
              <span className="text-warmBrown/80 leading-relaxed" data-id="element-702" data-mp="2uve3zn5ozjy4">{item}</span>
            </li>)}
        </ul>

        <div className="bg-warmBrown rounded-2xl p-5 text-cream" data-id="element-703" data-mp="2zuha7axerw7o">
          <p className="font-bold text-center text-lg" data-id="element-704" data-mp="226gykkmkxhms">
            Comments → engagement → cheaper CPM on ads → more distribution.
          </p>
        </div>
      </section>
    </motion.article>;
}
function FinchPawchiTopic() {
  const pairs = [{
    finch: 'Nobody: That one person who remembers to drink water because a bird on her phone told her to',
    pawchi: 'Nobody: That one person drinking water because a pixel version of her dog is judging her',
    referenceUrl: 'https://www.tiktok.com/@finchcare/video/7618231189844806926'
  }, {
    finch: 'Me trying to drink water so I can get more rainbow stones on Finch',
    pawchi: 'Me chugging water because I turned my dog into a Tamagotchi',
    referenceUrl: 'https://www.tiktok.com/@finchcare/video/7644182635153001742'
  }, {
    finch: 'Making my stupid bed so my Finch can get back from her stupid adventure',
    pawchi: 'Making my stupid bed because my dog somehow lives in my phone now',
    referenceUrl: 'https://www.tiktok.com/@madiebooth/video/7474039283083529503'
  }, {
    finch: 'Rotting in bed? Not anymore thanks to this cute self care app',
    pawchi: "Rotting in bed? My dog won't let me anymore",
    referenceUrl: 'https://www.tiktok.com/@finchcare/video/7457035886274907438'
  }, {
    finch: 'POV: your sink is overflowing with dishes and the only motivation to wash them is because of a silly little bird on your phone',
    pawchi: "POV: the only reason these dishes are getting done is because my dog gets sad when I don't",
    referenceUrl: 'https://www.tiktok.com/@finchcare/video/7642362206276881678'
  }, {
    finch: 'Me trying to act nonchalant but I literally have a bird on my phone reminding me to drink water',
    pawchi: 'Me trying to explain why a digital version of my dog controls my life',
    referenceUrl: 'https://www.tiktok.com/@finchcare/video/7644182635153001742'
  }, {
    finch: 'Download a silly little self care app not expecting it to work',
    pawchi: 'Downloaded an app that turned my dog into a virtual pet. Somehow my life is together now',
    referenceUrl: 'https://www.tiktok.com/@finchcare/video/7263861893255761194'
  }, {
    finch: 'I love being a girl in 2026 because someone made a Studio Ghibli self care app',
    pawchi: 'I love being alive in 2026 because I can turn my dog into a Tamagotchi',
    referenceUrl: 'https://www.tiktok.com/@reb.ponyo/video/7627477323406642445'
  }, {
    finch: 'POV: this silly goofy bird on your phone is the reason why you remember to treat yourself',
    pawchi: "POV: my dog has absolutely no idea he's responsible for my mental health now",
    referenceUrl: 'https://www.tiktok.com/@finchcare/video/7619002656144575758'
  }, {
    finch: "Checks my birb to see if she's done with her adventure",
    pawchi: 'Checking if my dog survived the day after I forgot to drink water',
    referenceUrl: 'https://www.tiktok.com/@finchcare/video/7129210768452521259'
  }];
  const bonusReferences = [{
    caption: 'Me, stressy, depressy and unmotivated',
    url: 'https://www.tiktok.com/@finchcare/video/7068061545644707118',
    handle: '@finchcare'
  }, {
    caption: 'Me: last year, "I wish I was healthier"',
    url: 'https://www.tiktok.com/@tylerandgerald/video/7314567467391700270',
    handle: '@tylerandgerald'
  }, {
    caption: 'Making my stupid bed',
    url: 'https://www.tiktok.com/@finchcare/video/7213858957826329899',
    handle: '@finchcare'
  }];
  function getHandle(url: string) {
    const match = url.match(/@([^/]+)/);
    return match ? `@${match[1]}` : '';
  }
  return <motion.article initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.4
  }} className="space-y-10" data-id="element-705" data-mp="px10i66idb1q">
      {/* Intro */}
      <header data-id="element-706" data-mp="zw03b84lecgt">
        <div className="inline-flex items-center gap-2 bg-lavender/10 text-lavender px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider mb-4" data-id="element-707" data-mp="13w0fem47ybkp">
          <Copy size={14} data-id="element-708" data-mp="18u2900z9ttaf" />
          Swipe File
        </div>
        <h2 className="text-3xl md:text-4xl font-black text-warmBrown mb-4" data-id="element-709" data-mp="35nx3ev7kpdwd">
          Finch → Pawchi Examples
        </h2>
        <p className="text-warmBrown/80 text-lg leading-relaxed" data-id="element-710" data-mp="3amqfqkb4iyuy">
          Finch's UGC playbook is already proven. We've remixed{' '}
          <strong className="text-warmBrown" data-id="element-711" data-mp="334if2ow5vakg">
            {pairs.length} of their top-performing caption styles
          </strong>{' '}
          for Pawchi. Use them as templates — swap in your pet's details and
          post.
        </p>
      </header>

      {/* Pawchi creator spotlight */}
      <section className="bg-white rounded-3xl p-8 md:p-10 shadow-soft border border-peach/20" data-id="element-712" data-mp="2obygm1jyhr9c">
        <div className="flex items-start gap-4 mb-6" data-id="element-713" data-mp="3lz7aaju426mf">
          <div className="w-12 h-12 rounded-full bg-peach/10 text-peach flex items-center justify-center flex-shrink-0" data-id="element-714" data-mp="3h3i808qpibmf">
            <Sparkles size={22} data-id="element-715" data-mp="3c1kfsp0bw6hc" />
          </div>
          <div data-id="element-716" data-mp="382bmtmd44cmu">
            <h3 className="text-2xl font-black text-warmBrown mb-1" data-id="element-717" data-mp="382k3lpccw23b">
              Pawchi Creator Spotlight
            </h3>
            <p className="text-warmBrown/60 text-sm" data-id="element-718" data-mp="20przmpsk116z">
              Start here — a creator already making Pawchi content. Study their
              pacing, tone, and hooks.
            </p>
          </div>
        </div>

        <a href="https://www.tiktok.com/@laneyand_toby" target="_blank" rel="noopener noreferrer" className="group flex items-center justify-between gap-4 p-5 bg-peach/10 hover:bg-peach/15 rounded-2xl border border-peach/30 transition-colors" data-id="element-719" data-mp="3l4cu8r0tvhks">
          <div className="flex items-center gap-4 min-w-0" data-id="element-720" data-mp="36d41i91mpg3f">
            <div className="w-11 h-11 rounded-xl bg-white text-peach flex items-center justify-center flex-shrink-0 shadow-soft" data-id="element-721" data-mp="31fc7n9hfbjwl">
              <PawPrint size={20} data-id="element-722" data-mp="2xbe6yucga11f" />
            </div>
            <div className="min-w-0" data-id="element-723" data-mp="2sd2yoo1szylb">
              <p className="font-black text-warmBrown truncate" data-id="element-724" data-mp="2se4jvlcja1gr">
                @laneyand_toby
              </p>
              <p className="text-sm text-warmBrown/60" data-id="element-725" data-mp="2ngmaxuyinm8r">
                Active Pawchi UGC creator on TikTok
              </p>
            </div>
          </div>
          <ArrowRight size={18} className="text-peach group-hover:translate-x-1 transition-transform flex-shrink-0" data-id="element-726" data-mp="lo6hh4mp7nzy" />
        </a>

        <Callout color="lavender" icon={<Lightbulb size={16} data-id="element-728" data-mp="y4fvr5gbijej" />} title="What to take from it" data-id="element-727" data-mp="y5qz545upp54">
          Watch how they open a video, how quickly they get to the companion,
          and how naturally the self-care angle comes through.{' '}
          <strong data-id="element-729" data-mp="17xmx8f7xtf9c">Borrow the structure, not the script</strong> — your version
          should sound like you.
        </Callout>
      </section>

      {/* Legend */}
      <div className="grid sm:grid-cols-2 gap-3" data-id="element-730" data-mp="f7o5gc2cz40z">
        <div className="bg-white rounded-2xl p-4 border border-warmBrown/10 flex items-center gap-3" data-id="element-731" data-mp="k5zhmtg4lqmd">
          <div className="w-10 h-10 rounded-full bg-warmBrown/10 text-warmBrown/60 flex items-center justify-center flex-shrink-0" data-id="element-732" data-mp="p52is2szjcp2">
            <Bird size={20} data-id="element-733" data-mp="1vk399sz8r2o9" />
          </div>
          <div data-id="element-734" data-mp="1vn91hh362ko7">
            <p className="text-xs font-bold uppercase tracking-wider text-warmBrown/40" data-id="element-735" data-mp="20k7pdhw8lvdy">
              Original
            </p>
            <p className="font-bold text-warmBrown text-sm" data-id="element-736" data-mp="h6upeh8tfji">Finch caption</p>
          </div>
        </div>
        <div className="bg-white rounded-2xl p-4 border border-peach/30 flex items-center gap-3" data-id="element-737" data-mp="3rn7z546pdaw6">
          <div className="w-10 h-10 rounded-full bg-peach/10 text-peach flex items-center justify-center flex-shrink-0" data-id="element-738" data-mp="9hmvuhaikal7">
            <PawPrint size={20} data-id="element-739" data-mp="5hkru1hb352r" />
          </div>
          <div data-id="element-740" data-mp="3dwmog2rek79d">
            <p className="text-xs font-bold uppercase tracking-wider text-peach" data-id="element-741" data-mp="3dw37opdhnowx">
              Remixed
            </p>
            <p className="font-bold text-warmBrown text-sm" data-id="element-742" data-mp="38z2yi5lce61l">Pawchi variant</p>
          </div>
        </div>
      </div>

      {/* Comparison pairs */}
      <section className="space-y-5" data-id="element-743" data-mp="3hyhqxal2kqoq">
        {pairs.map((pair, index) => <article key={index} className="bg-white rounded-3xl p-6 md:p-8 shadow-soft border border-warmBrown/5" data-id="element-744" data-mp="3hwdcvztgibaq" data-mpi={index}>
            <div className="flex items-center gap-3 mb-5" data-id="element-745" data-mp="2q83fdl0j3qg8">
              <span className="w-8 h-8 rounded-full bg-warmBrown text-cream flex items-center justify-center font-black text-sm" data-id="element-746" data-mp="2q5h87mhjvcyj">
                {index + 1}
              </span>
              <span className="text-xs font-bold uppercase tracking-wider text-warmBrown/40" data-id="element-747" data-mp="2kvejukfm3iu4">
                Caption Pair
              </span>
            </div>

            <div className="grid md:grid-cols-[1fr_auto_1fr] gap-4 md:gap-5 items-stretch" data-id="element-748" data-mp="2b3h3kz9qy0oj">
              {/* Finch side */}
              <div className="bg-cream/60 rounded-2xl p-5 border border-warmBrown/10" data-id="element-749" data-mp="2yue6xnnh7po6">
                <div className="flex items-center gap-2 mb-3" data-id="element-750" data-mp="33rmts1jkkhvr">
                  <Bird size={16} className="text-warmBrown/40" data-id="element-751" data-mp="2ow6t3dohhnqe" />
                  <p className="text-xs font-bold uppercase tracking-wider text-warmBrown/40" data-id="element-752" data-mp="2oxrnn3ast6o9">
                    Finch
                  </p>
                </div>
                <p className="text-warmBrown/80 italic leading-relaxed" data-id="element-753" data-mp="1dfqm88qzwff5">
                  "{pair.finch}"
                </p>
              </div>

              {/* Arrow */}
              <div className="flex md:flex-col items-center justify-center text-peach md:py-4" data-id="element-754" data-mp="1yn9fl3qrxjsq">
                <ArrowRight size={24} className="md:hidden" data-id="element-755" data-mp="1tvhjkdoumlv7" />
                <ArrowRight size={24} className="hidden md:block" data-id="element-756" data-mp="1tty6sx2eisy6" />
              </div>

              {/* Pawchi side */}
              <div className="bg-peach/10 rounded-2xl p-5 border border-peach/30" data-id="element-757" data-mp="1jy3gdfrxrtku">
                <div className="flex items-center justify-between gap-2 mb-3" data-id="element-758" data-mp="1jw0he68t2q3z">
                  <div className="flex items-center gap-2" data-id="element-759" data-mp="2hku1q325m49n">
                    <PawPrint size={16} className="text-peach" data-id="element-760" data-mp="2cm8yrvvip6hi" />
                    <p className="text-xs font-bold uppercase tracking-wider text-peach" data-id="element-761" data-mp="27nfla3g8dfhc">
                      Pawchi
                    </p>
                  </div>
                  {pair.referenceUrl && <a href={pair.referenceUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 text-xs font-bold text-peach hover:text-coral transition-colors" data-id="element-762" data-mp="w80trf6sjftm">
                      <Film size={12} data-id="element-763" data-mp="37v2xcpqrsyoa" />
                      <span data-id="element-764" data-mp="37w5jkkd5ecxv">{getHandle(pair.referenceUrl)}</span>
                    </a>}
                </div>
                <p className="text-warmBrown leading-relaxed font-medium" data-id="element-765" data-mp="3csvyv5h4p4i8">
                  "{pair.pawchi}"
                </p>
              </div>
            </div>
          </article>)}
      </section>

      {/* Pawchi-original captions */}
      <section className="bg-white rounded-3xl p-8 md:p-10 shadow-soft border border-warmBrown/5" data-id="element-766" data-mp="3ql2i50fkvrlw">
        <div className="flex items-start gap-4 mb-6" data-id="element-767" data-mp="3vm8c11kz5kx0">
          <div className="w-12 h-12 rounded-full bg-peach/10 text-peach flex items-center justify-center flex-shrink-0" data-id="element-768" data-mp="4evrqdosorcv">
            <PawPrint size={22} data-id="element-769" data-mp="217p76scyn5bt" />
          </div>
          <div data-id="element-770" data-mp="21909souo671c">
            <h3 className="text-2xl font-black text-warmBrown mb-1" data-id="element-771" data-mp="219ifsd74vzmg">
              More Pawchi-Original Captions
            </h3>
            <p className="text-warmBrown/60 text-sm" data-id="element-772" data-mp="1y519ldpa0uw5">
              Original ideas built around the chase-and-transform moment — no
              Finch counterpart.
            </p>
          </div>
        </div>

        <div className="space-y-3" data-id="element-773" data-mp="2840i8wa1kqj5">
          {["POV: me chasing my dog around the house because apparently turning him into a Tamagotchi is the only way I'll start taking care of myself.", "I turned my dog into a Tamagotchi and now he's somehow managing my life better than I am.", 'Was trying to make a digital version of my dog. Accidentally ended up in a healthier lifestyle.', "Me: can't stick to a habit tracker for more than 3 days.\nAlso me: chasing my dog so I can turn him into a Tamagotchi and finally get my life together."].map((caption, idx) => <div key={idx} className="bg-peach/10 rounded-2xl p-5 border border-peach/30" data-id="element-774" data-mp="30sxou24w4yw2" data-mpi={idx}>
              <div className="flex items-center gap-2 mb-2" data-id="element-775" data-mp="2vri4kcajeweq">
                <span className="w-6 h-6 rounded-full bg-peach text-white flex items-center justify-center font-black text-xs flex-shrink-0" data-id="element-776" data-mp="3fgfub2qa1xjj">
                  {idx + 1}
                </span>
                <p className="text-xs font-bold uppercase tracking-wider text-peach" data-id="element-777" data-mp="35g5hvkc2gu5f">
                  Pawchi
                </p>
              </div>
              <p className="text-warmBrown leading-relaxed font-medium whitespace-pre-line" data-id="element-778" data-mp="2vr5hpxltvspn">
                "{caption}"
              </p>
            </div>)}
        </div>
      </section>

      {/* Bonus references */}
      <section className="bg-white rounded-3xl p-8 md:p-10 shadow-soft border border-warmBrown/5" data-id="element-779" data-mp="2mr8odiohu5o9">
        <div className="flex items-start gap-4 mb-6" data-id="element-780" data-mp="2ror0fhxt510h">
          <div className="w-12 h-12 rounded-full bg-lavender/10 text-lavender flex items-center justify-center flex-shrink-0" data-id="element-781" data-mp="2rnfsd5xbx73k">
            <Film size={22} data-id="element-782" data-mp="2hr30mdlch3bg" />
          </div>
          <div data-id="element-783" data-mp="2hqurmwscei5j">
            <h3 className="text-2xl font-black text-warmBrown mb-1" data-id="element-784" data-mp="2htgw2njxshjj">
              Bonus Reference Videos
            </h3>
            <p className="text-warmBrown/60 text-sm" data-id="element-785" data-mp="2t7skfysw07xk">
              Extra TikToks in the Finch / self-care UGC style worth studying.
            </p>
          </div>
        </div>

        <div className="space-y-3" data-id="element-786" data-mp="2oasednw1f56g">
          {bonusReferences.map((ref, idx) => <a key={idx} href={ref.url} target="_blank" rel="noopener noreferrer" className="group flex items-center justify-between gap-4 p-4 bg-cream/60 hover:bg-peach/10 rounded-xl border border-warmBrown/5 hover:border-peach/30 transition-all" data-id="element-787" data-mp="2j9cva1df78qp" data-mpi={idx}>
              <div className="flex items-center gap-3 min-w-0" data-id="element-788" data-mp="20j3ki33ki8ne">
                <div className="w-9 h-9 rounded-lg bg-white text-peach flex items-center justify-center flex-shrink-0 shadow-soft" data-id="element-789" data-mp="20ky5fheua0rh">
                  <Film size={16} data-id="element-790" data-mp="1qkxf3bijykds" />
                </div>
                <div className="min-w-0" data-id="element-791" data-mp="1qlgyyxrrjiug">
                  <p className="font-medium text-warmBrown italic truncate" data-id="element-792" data-mp="1gh0iq3adfzq4">
                    "{ref.caption}"
                  </p>
                  <p className="text-xs text-warmBrown/50 font-bold" data-id="element-793" data-mp="1lf25ozax4j6v">
                    {ref.handle}
                  </p>
                </div>
              </div>
              <ArrowRight size={18} className="text-warmBrown/30 group-hover:text-peach group-hover:translate-x-1 transition-all flex-shrink-0" data-id="element-794" data-mp="1vdzp5nthlmj0" />
            </a>)}
        </div>
      </section>

      {/* Closing tip */}
      <Callout color="lavender" icon={<Lightbulb size={18} data-id="element-796" data-mp="17of3uy9v2d6k" />} title="How to use this swipe file" data-id="element-795" data-mp="12nhpkwrz23ac">
        Don't copy-paste verbatim. Pick a caption that fits your video, then{' '}
        <strong data-id="element-797" data-mp="1ch871hpoldgj">swap in specific details about your pet</strong> — breed, name,
        a unique quirk. The more specific, the higher the engagement.
      </Callout>
    </motion.article>;
}
function UgcBriefTopic() {
  const briefComponents = [{
    icon: <Anchor size={18} data-id="element-798" data-mp="3ofe19wznd9yk" />,
    label: 'The hook',
    desc: 'Exact words and delivery style to open with'
  }, {
    icon: <Wand2 size={18} data-id="element-799" data-mp="3tatgas9e5bwk" />,
    label: 'The transformation demo',
    desc: 'Exactly how to show pet upload → animated result'
  }, {
    icon: <Heart size={18} data-id="element-800" data-mp="3jdyiycouthjv" />,
    label: 'The self-care loop',
    desc: 'How to connect habits to pet health in the demo'
  }, {
    icon: <Smile size={18} data-id="element-801" data-mp="35lict30np3eq" />,
    label: 'The emotional beat',
    desc: 'The moment of genuine delight or surprise to capture'
  }, {
    icon: <Link2 size={18} data-id="element-802" data-mp="2vq6vccxv5i3a" />,
    label: 'The CTA',
    desc: '"Comment your pet and I\'ll show you" / link in bio / App Store'
  }];
  const hooks = ['"I accidentally found the cutest way to stay consistent with my habits."', '"My dog is now judging my self-care."', '"This app turned my pet into a little Tamagotchi."', '"I uploaded a photo of my pet and wasn\'t expecting this."'];
  const transformationSteps = ['Show the real pet first.', 'Capture a cute moment of the pet looking at the camera.', 'Open Pawchi and upload a photo of the pet.', 'Record the transformation process.', 'Reveal the generated Pawchi companion.', 'Spend a few seconds showing the resemblance between the real pet and the digital version.', 'Encourage creators to react genuinely to the result.'];
  const selfCareSteps = ['Briefly explain or demonstrate that completing habits affects the pet.', 'Show one or two habit completions such as drinking water, taking a walk, journaling, or checking in.', 'Return to the app and show the pet reacting positively.', 'The focus should be on the emotional connection, not on explaining features.'];
  const ctas = ['"If you have a pet, you need to try this."', '"Upload your pet and see what it becomes."', '"Link in bio if you want your own Pawchi."', '"Comment your pet and I\'ll show you what it would look like."'];
  const donts = ['Do not feature copyrighted or trademarked plushies.', 'Do not mention pricing.', 'Do not mention subscriptions.', 'Do not show paywalls.', 'Do not say "download now".', 'Do not make it sound like a traditional ad.', 'Do not over-explain features.', 'Do not use corporate language.'];
  return <motion.article initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.4
  }} className="space-y-10" data-id="element-803" data-mp="2l5w2kh44q868">
      {/* Intro */}
      <header data-id="element-804" data-mp="2u6u8x621irrz">
        <div className="inline-flex items-center gap-2 bg-sage/10 text-sage px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider mb-4" data-id="element-805" data-mp="2u3yevstbcn8t">
          <FileText size={14} data-id="element-806" data-mp="zt34ckykiy3e" />
          Creative Brief
        </div>
        <h2 className="text-3xl md:text-4xl font-black text-warmBrown mb-4" data-id="element-807" data-mp="14qutx8bqq84f">
          UGC Brief Template
        </h2>
        <p className="text-warmBrown/80 text-lg leading-relaxed" data-id="element-808" data-mp="x7vbp600mmmn">
          The full creative brief for Pawchi videos. Use this as your shot list
          — every video should hit{' '}
          <strong className="text-warmBrown" data-id="element-809" data-mp="nh92btiw6sce">all five components</strong> and
          avoid the don'ts.
        </p>
      </header>

      {/* Goal */}
      <section className="bg-gradient-to-br from-peach to-coral rounded-3xl p-8 md:p-10 text-white" data-id="element-810" data-mp="ikiolcuk88u5">
        <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider mb-4" data-id="element-811" data-mp="1g5oem8an2wk1">
          <Target size={14} data-id="element-812" data-mp="167ie9v4hdyha" />
          The Goal
        </div>
        <p className="text-xl md:text-2xl font-bold leading-snug" data-id="element-813" data-mp="16a4j3mzzlzvt">
          Show how a real pet can be turned into a digital companion that
          motivates self-care.
        </p>
        <p className="text-white/90 leading-relaxed mt-4" data-id="element-814" data-mp="3qwejmzeucgo5">
          The video should feel like a{' '}
          <strong className="text-white" data-id="element-815" data-mp="3mz08v3bii0u1">personal discovery</strong>, not a
          sponsored promotion.
        </p>
      </section>

      {/* Brief components overview */}
      <section className="bg-white rounded-3xl p-8 md:p-10 shadow-soft border border-warmBrown/5" data-id="element-816" data-mp="1jgin4ed20kaq">
        <h3 className="text-2xl font-black text-warmBrown mb-2" data-id="element-817" data-mp="14rmiyse4brfe">
          Every brief includes 5 components
        </h3>
        <p className="text-warmBrown/60 text-sm mb-6" data-id="element-818" data-mp="19n1uveskfd96">
          Hit all five — in this order — for a complete video.
        </p>

        <div className="space-y-3" data-id="element-819" data-mp="22djx6dlgtalj">
          {briefComponents.map((item, index) => <div key={item.label} className="flex items-center gap-4 p-4 bg-cream/60 rounded-xl" data-id="element-820" data-mp="1oe0vo3n5sxi7" data-mpi={index}>
              <span className="w-8 h-8 rounded-full bg-peach text-white flex items-center justify-center font-black text-sm flex-shrink-0" data-id="element-821" data-mp="1seb37kqlnvz6">
                {index + 1}
              </span>
              <div className="text-peach flex-shrink-0" data-id="element-822" data-mp="h1ie6hp71lmt">{item.icon}</div>
              <div className="flex-1 min-w-0" data-id="element-823" data-mp="9gob1127680y">
                <p className="font-bold text-warmBrown" data-id="element-824" data-mp="9fd4wula4o6o">{item.label}</p>
                <p className="text-sm text-warmBrown/60" data-id="element-825" data-mp="4imqebp4i0nd">{item.desc}</p>
              </div>
            </div>)}
        </div>
      </section>

      {/* Step 1: Hook */}
      <BriefStep number={1} title="Hook" subtitle="Open within the first 1–2 seconds." color="peach" icon={<Anchor size={22} data-id="element-827" data-mp="3mwmadckwsqbe" />} data-id="element-826" data-mp="egan376ahi86">
        <p className="text-xs font-bold uppercase tracking-wider text-warmBrown/40 mb-3" data-id="element-828" data-mp="3mthw1mdqce70">
          Choose one
        </p>
        <div className="space-y-2 mb-5" data-id="element-829" data-mp="fzx06ct07o2">
          {hooks.map(hook => <div key={hook} className="bg-cream/60 rounded-xl px-4 py-3 text-warmBrown/80 italic border-l-4 border-peach/40" data-id="element-830" data-mp="i2wdgzujd5g">
              {hook}
            </div>)}
        </div>
        <Callout color="peach" icon={<Megaphone size={16} data-id="element-832" data-mp="2z5guwyivs01m" />} title="Delivery" data-id="element-831" data-mp="2z6rxww4i53ro">
          Should feel natural, slightly surprised, and conversational.
        </Callout>
      </BriefStep>

      {/* Step 2: Transformation Demo */}
      <BriefStep number={2} title="Transformation Demo" subtitle="The reveal is the hero of the video." color="coral" icon={<Film size={22} data-id="element-834" data-mp="6g4vag5yodaw" />} data-id="element-833" data-mp="3suo8i9j79mfs">
        <ol className="space-y-3" data-id="element-835" data-mp="6f38jefl22dc">
          {transformationSteps.map((step, idx) => <li key={step} className="flex items-start gap-3" data-id="element-836" data-mp="35wl2q3g2z27r" data-mpi={idx}>
              <span className="mt-0.5 w-6 h-6 rounded-full bg-coral/15 text-coral flex items-center justify-center font-black text-xs flex-shrink-0" data-id="element-837" data-mp="39x511ace4bvh">
                {idx + 1}
              </span>
              <span className="text-warmBrown/80 leading-relaxed" data-id="element-838" data-mp="3jvb0zmemz7xp">{step}</span>
            </li>)}
        </ol>
      </BriefStep>

      {/* Step 3: Self-Care Loop */}
      <BriefStep number={3} title="Self-Care Loop" subtitle="Connect habits to pet wellbeing." color="lavender" icon={<Heart size={22} data-id="element-840" data-mp="2jndzbdmyrjll" />} data-id="element-839" data-mp="u5qrcur1eceo">
        <ol className="space-y-3 mb-5" data-id="element-841" data-mp="2jmkxmr2v3kab">
          {selfCareSteps.map((step, idx) => <li key={step} className="flex items-start gap-3" data-id="element-842" data-mp="2epcjr2oqy2ev" data-mpi={idx}>
              <span className="mt-0.5 w-6 h-6 rounded-full bg-lavender/15 text-lavender flex items-center justify-center font-black text-xs flex-shrink-0" data-id="element-843" data-mp="29wt29umxun4s">
                {idx + 1}
              </span>
              <span className="text-warmBrown/80 leading-relaxed" data-id="element-844" data-mp="20x62fd9uxpdu">{step}</span>
            </li>)}
        </ol>
      </BriefStep>

      {/* Step 4: Emotional Beat */}
      <BriefStep number={4} title="Emotional Beat" subtitle="The single most important moment in the video." color="sage" icon={<Smile size={22} data-id="element-846" data-mp="1m0x54h9j1m42" />} data-id="element-845" data-mp="1qygtwb3upha9">
        <p className="text-warmBrown/80 leading-relaxed mb-4" data-id="element-847" data-mp="3lchqepbxhs76">
          Capture the moment where the creator realizes:
        </p>
        <div className="bg-sage/10 border-l-4 border-sage/50 rounded-xl px-5 py-4 text-warmBrown/90 italic leading-relaxed mb-5" data-id="element-848" data-mp="3gd56odgct18t">
          "Wait… now I actually want to complete my habits because I don't want
          my pet to be sad."
        </div>
        <Callout color="sage" icon={<Sparkles size={16} data-id="element-850" data-mp="2ggiox2cbpfi9" />} title="What to capture" data-id="element-849" data-mp="2u98flk2sr8lp">
          The creator should <strong data-id="element-851" data-mp="2kgj44p78xuqd">smile, laugh, or react naturally</strong>{' '}
          to the pet's response. This is the moment that converts viewers.
        </Callout>
      </BriefStep>

      {/* Step 5: CTA */}
      <BriefStep number={5} title="CTA" subtitle="End on an invitation, not a sales pitch." color="peach" icon={<Link2 size={22} data-id="element-853" data-mp="1xixznu5ncex4" />} data-id="element-852" data-mp="2bgwawqoo7v8e">
        <p className="text-xs font-bold uppercase tracking-wider text-warmBrown/40 mb-3" data-id="element-854" data-mp="21i6qor9axyoz">
          Choose one
        </p>
        <div className="space-y-2" data-id="element-855" data-mp="3rvxlw64j87dd">
          {ctas.map(cta => <div key={cta} className="bg-cream/60 rounded-xl px-4 py-3 text-warmBrown/80 italic border-l-4 border-peach/40" data-id="element-856" data-mp="3vw7r3gki2tr6">
              {cta}
            </div>)}
        </div>
      </BriefStep>

      {/* Copyright rules */}
      <section className="bg-white rounded-3xl p-8 md:p-10 shadow-soft border border-coral/20" data-id="element-857" data-mp="1g5pqv9ogbajt">
        <div className="flex items-start gap-4 mb-5" data-id="element-858" data-mp="1u10fw6g0l1g9">
          <div className="w-12 h-12 rounded-full bg-coral/10 text-coral flex items-center justify-center flex-shrink-0" data-id="element-859" data-mp="1p760vgbctani">
            <Ban size={22} data-id="element-860" data-mp="23vk2xp0y4v30" />
          </div>
          <div data-id="element-861" data-mp="1yyag8h4xyxiv">
            <p className="text-xs font-bold uppercase tracking-wider text-coral mb-1" data-id="element-862" data-mp="1yytnn3wyu3in">
              Non-Negotiable
            </p>
            <h3 className="text-2xl font-black text-warmBrown" data-id="element-863" data-mp="2cx9tksn07pzq">
              No Copyrighted or Trademarked Plushies
            </h3>
            <p className="text-warmBrown/60 text-sm mt-1" data-id="element-864" data-mp="27wvsjujtlgb7">
              Applies to the companion you feature and to anything visible on
              camera.
            </p>
          </div>
        </div>

        <p className="text-warmBrown/80 leading-relaxed mb-5" data-id="element-865" data-mp="1ufoc1nut5ikz">
          Licensed characters and branded plushies are protected trademarks. Do
          not turn them into a Pawchi, and do not feature them in your video —
          it exposes both you and Pawchi to takedowns and legal risk.
        </p>

        <p className="text-xs font-bold uppercase tracking-wider text-warmBrown/40 mb-2" data-id="element-866" data-mp="1pglespl2kgnk">
          Do not use
        </p>
        <div className="flex flex-wrap gap-2 mb-5" data-id="element-867" data-mp="2d5w9pqfqngts">
          {['Disney characters', 'Jellycat', 'Squishmallows', 'Sanrio / Hello Kitty', 'Pokémon', 'Build-A-Bear licensed lines', 'Any branded or licensed character plush'].map(brand => <span key={brand} className="px-3 py-1.5 bg-coral/10 text-coral rounded-lg font-bold text-sm border border-coral/20" data-id="element-868" data-mp="28dmqsud1jh10">
              {brand}
            </span>)}
        </div>

        <Callout color="sage" icon={<CheckCircle2 size={16} data-id="element-870" data-mp="pf6wxo4jdtri" />} title="Use this instead" data-id="element-869" data-mp="pgi0bmu2kzi3">
          Your <strong data-id="element-871" data-mp="kgn73cmtnxtv">real pet</strong>, a{' '}
          <strong data-id="element-872" data-mp="kfuah4hkuopg">generic, unbranded plushie or stuffed animal</strong>, or a
          non-licensed figure. Before you hit record, check the frame for
          branded plushies in the background too.
        </Callout>
      </section>

      {/* DO NOT section */}
      <section className="bg-warmBrown rounded-3xl p-8 md:p-10 text-cream" data-id="element-873" data-mp="6ioy6mr9stlr">
        <div className="flex items-start gap-4 mb-6" data-id="element-874" data-mp="1jm41xctw7sk">
          <div className="w-12 h-12 rounded-full bg-coral/20 text-coral flex items-center justify-center flex-shrink-0" data-id="element-875" data-mp="1l5jjlqnueta">
            <Ban size={22} data-id="element-876" data-mp="bh8iyju4nzcj" />
          </div>
          <div data-id="element-877" data-mp="bg7567lq8yr4">
            <h3 className="text-2xl font-black mb-1" data-id="element-878" data-mp="bfp3uwk7jucc">DO NOT</h3>
            <p className="text-cream/60 text-sm" data-id="element-879" data-mp="1qwpkq5ndc0r5">
              These will sink the video. Avoid every one.
            </p>
          </div>
        </div>

        <ul className="space-y-3" data-id="element-880" data-mp="1myi0h0tp4hb7">
          {donts.map(item => <li key={item} className="flex items-start gap-3" data-id="element-881" data-mp="jkq91mbwjgru">
              <XCircle size={18} className="text-coral mt-0.5 flex-shrink-0" data-id="element-882" data-mp="ojjm5dna15rh" />
              <span className="text-cream/85 leading-relaxed" data-id="element-883" data-mp="tjp585fhdjxy">{item}</span>
            </li>)}
        </ul>
      </section>

      {/* Closing mantra */}
      <section className="bg-white rounded-3xl p-8 md:p-10 shadow-soft border border-warmBrown/5 text-center" data-id="element-884" data-mp="xk7y82t40w1q">
        <p className="text-xs font-bold uppercase tracking-wider text-warmBrown/40 mb-4" data-id="element-885" data-mp="snnpxobfcb9">
          Think
        </p>
        <p className="text-2xl md:text-3xl font-black text-warmBrown leading-tight" data-id="element-886" data-mp="9vgelztl5m0k">
          Personal discovery. Emotional reaction. Cute pet moment. Self-care
          motivation.
        </p>
      </section>
    </motion.article>;
}
interface BriefStepProps {
  number: number;
  title: string;
  subtitle: string;
  color: 'peach' | 'coral' | 'lavender' | 'sage';
  icon: React.ReactNode;
  children: React.ReactNode;
}
function BriefStep({
  number,
  title,
  subtitle,
  color,
  icon,
  children
}: BriefStepProps) {
  const colorMap = {
    peach: {
      bg: 'bg-peach/10',
      text: 'text-peach',
      solid: 'bg-peach'
    },
    coral: {
      bg: 'bg-coral/10',
      text: 'text-coral',
      solid: 'bg-coral'
    },
    lavender: {
      bg: 'bg-lavender/10',
      text: 'text-lavender',
      solid: 'bg-lavender'
    },
    sage: {
      bg: 'bg-sage/10',
      text: 'text-sage',
      solid: 'bg-sage'
    }
  };
  const c = colorMap[color];
  return <section className="bg-white rounded-3xl p-8 md:p-10 shadow-soft border border-warmBrown/5" data-id="element-887" data-mp="2n01wsyn1h4wy">
      <div className="flex items-start gap-4 mb-6" data-id="element-888" data-mp="2i0z1i5wv2d26">
        <div className={`w-14 h-14 rounded-2xl ${c.solid} text-white flex items-center justify-center flex-shrink-0 font-black text-xl`} data-id="element-889" data-mp="2e29gps9htt8i">
          {number}
        </div>
        <div className="flex-1 min-w-0" data-id="element-890" data-mp="242qzvkovqnko">
          <div className="flex items-center gap-2 mb-1" data-id="element-891" data-mp="2442c88we53ne">
            <span className={c.text} data-id="element-892" data-mp="7zvy1riwkcft">{icon}</span>
            <p className={`text-xs font-bold uppercase tracking-wider ${c.text}`} data-id="element-893" data-mp="828q4xidk36l">
              Step {number}
            </p>
          </div>
          <h3 className="text-2xl font-black text-warmBrown mb-1" data-id="element-894" data-mp="3uexgv84p1c5a">{title}</h3>
          <p className="text-warmBrown/60 text-sm" data-id="element-895" data-mp="38no8udnup24">{subtitle}</p>
        </div>
      </div>
      <div data-id="element-896" data-mp="3leiu04c2zozo">{children}</div>
    </section>;
}
interface EngagementBucketProps {
  percent: number;
  label: string;
  color: 'peach' | 'coral' | 'lavender' | 'sage';
  items: string[];
  goal: string;
}
function EngagementBucket({
  percent,
  label,
  color,
  items,
  goal
}: EngagementBucketProps) {
  const colorMap = {
    peach: {
      bg: 'bg-peach/10',
      text: 'text-peach',
      solid: 'bg-peach',
      dot: 'bg-peach'
    },
    coral: {
      bg: 'bg-coral/10',
      text: 'text-coral',
      solid: 'bg-coral',
      dot: 'bg-coral'
    },
    lavender: {
      bg: 'bg-lavender/10',
      text: 'text-lavender',
      solid: 'bg-lavender',
      dot: 'bg-lavender'
    },
    sage: {
      bg: 'bg-sage/10',
      text: 'text-sage',
      solid: 'bg-sage',
      dot: 'bg-sage'
    }
  };
  const c = colorMap[color];
  return <div className="bg-cream/60 rounded-2xl p-5 md:p-6" data-id="element-897" data-mp="38xr8ycy6awyx">
      <div className="flex items-center gap-4 mb-4" data-id="element-898" data-mp="345g91a3fnb6d">
        <div className={`${c.solid} text-white font-black text-lg md:text-xl rounded-2xl px-4 py-2 flex-shrink-0`} data-id="element-899" data-mp="343n2dustkqyd">
          {percent}%
        </div>
        <h4 className="font-black text-warmBrown text-lg md:text-xl" data-id="element-900" data-mp="3cx8fzat90267">
          {label}
        </h4>
      </div>

      {/* Visual percentage bar */}
      <div className="h-1.5 bg-warmBrown/5 rounded-full overflow-hidden mb-5" data-id="element-901" data-mp="3mw7o8sa3pvso">
        <div className={`h-full ${c.solid} rounded-full`} style={{
        width: `${percent}%`
      }} data-id="element-902" data-mp="3mu4ohgj5coar" />
      </div>

      <ul className="grid sm:grid-cols-2 gap-x-4 gap-y-2 mb-5" data-id="element-903" data-mp="1sj836jmyc9e0">
        {items.map(item => <li key={item} className="flex items-center gap-2 text-warmBrown/80 text-sm" data-id="element-904" data-mp="2i7dlfowh63vh">
            <span className={`w-1.5 h-1.5 rounded-full ${c.dot} flex-shrink-0`} data-id="element-905" data-mp="2m8fiq06u05ut"></span>
            {item}
          </li>)}
      </ul>

      <div className={`${c.bg} rounded-xl px-4 py-3`} data-id="element-906" data-mp="2w6d6ynooy2nf">
        <p className="text-xs font-bold uppercase tracking-wider text-warmBrown/40 mb-1" data-id="element-907" data-mp="2w3qr80rncgu4">
          Goal
        </p>
        <p className={`text-sm font-bold ${c.text}`} data-id="element-908" data-mp="356jhq1t08oiw">{goal}</p>
      </div>
    </div>;
}
interface PhaseCardProps {
  phase: string;
  title: string;
  color: 'peach' | 'coral' | 'lavender' | 'sage';
  icon: React.ReactNode;
  children: React.ReactNode;
}
function PhaseCard({
  phase,
  title,
  color,
  icon,
  children
}: PhaseCardProps) {
  const colorMap = {
    peach: {
      bg: 'bg-peach/10',
      text: 'text-peach'
    },
    coral: {
      bg: 'bg-coral/10',
      text: 'text-coral'
    },
    lavender: {
      bg: 'bg-lavender/10',
      text: 'text-lavender'
    },
    sage: {
      bg: 'bg-sage/10',
      text: 'text-sage'
    }
  };
  const c = colorMap[color];
  return <section className="bg-white rounded-3xl p-8 md:p-10 shadow-soft border border-warmBrown/5" data-id="element-909" data-mp="18aow3k6ryhe9">
      <div className="flex items-start gap-4 mb-6" data-id="element-910" data-mp="13b2ih9n1az4x">
        <div className={`w-12 h-12 rounded-full ${c.bg} ${c.text} flex items-center justify-center flex-shrink-0`} data-id="element-911" data-mp="yb7q11nm21hr">
          {icon}
        </div>
        <div data-id="element-912" data-mp="1qz3p2d0nk5hp">
          <p className={`text-xs font-bold uppercase tracking-wider ${c.text} mb-1`} data-id="element-913" data-mp="1qyk2uk3yyuxv">
            {phase}
          </p>
          <h3 className="text-2xl font-black text-warmBrown" data-id="element-914" data-mp="1m6akbp56ox5m">{title}</h3>
        </div>
      </div>
      <div className="space-y-4" data-id="element-915" data-mp="1h8qtzqv7otxb">{children}</div>
    </section>;
}
interface RuleProps {
  icon: React.ReactNode;
  children: React.ReactNode;
  negative?: boolean;
}
function Rule({
  icon,
  children,
  negative
}: RuleProps) {
  return <div className="flex items-start gap-3" data-id="element-916" data-mp="1ia4p83ltudo6">
      <div className={`mt-0.5 flex-shrink-0 ${negative ? 'text-coral' : 'text-peach'}`} data-id="element-917" data-mp="1i9biv3qs5q6k">
        {icon}
      </div>
      <p className="text-warmBrown/80 leading-relaxed" data-id="element-918" data-mp="1n2xxh1gi8450">{children}</p>
    </div>;
}
interface CalloutProps {
  color: 'peach' | 'sage' | 'lavender' | 'coral';
  icon: React.ReactNode;
  title: string;
  children: React.ReactNode;
}
function Callout({
  color,
  icon,
  title,
  children
}: CalloutProps) {
  const colorMap = {
    peach: {
      bg: 'bg-peach/10',
      border: 'border-peach/20',
      text: 'text-peach'
    },
    sage: {
      bg: 'bg-sage/10',
      border: 'border-sage/20',
      text: 'text-sage'
    },
    lavender: {
      bg: 'bg-lavender/10',
      border: 'border-lavender/20',
      text: 'text-lavender'
    },
    coral: {
      bg: 'bg-coral/10',
      border: 'border-coral/20',
      text: 'text-coral'
    }
  };
  const c = colorMap[color];
  return <div className={`${c.bg} ${c.border} border rounded-2xl p-5 mt-6`} data-id="element-919" data-mp="ll5jav8ptnz5">
      <div className="flex items-center gap-2 mb-2" data-id="element-920" data-mp="dza3j5p21ftg">
        <span className={c.text} data-id="element-921" data-mp="918k2jnpvehg">{icon}</span>
        <p className={`font-bold ${c.text}`} data-id="element-922" data-mp="906yhl92r9lh">{title}</p>
      </div>
      <p className="text-warmBrown/80 leading-relaxed text-sm" data-id="element-923" data-mp="n0re68jp0par">{children}</p>
    </div>;
}